function setNectorAlt() {
  const img = document.querySelector('img.nector-btn-icon');
  if (img && img.getAttribute('alt') !== 'nector gift redeem') {
    img.setAttribute('alt', 'nector gift redeem');
  }
}

/* Index_image_slider */
new Swiper(".Index_image_slider", {
  slidesPerView: 5,
  slidesPerGroup: 5,
  spaceBetween: 8,
  freeMode: false,
  loop: false,
  mousewheel: false,
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
  },
  breakpoints: {
    0: {
      spaceBetween: 8,
      slidesPerView: 2.5,
      mousewheel: true,
      slidesPerGroup: 2
    },
    750: {
      spaceBetween: 8,
      slidesPerView: 3.8,
      slidesPerGroup: 3
    },
    992: {
      spaceBetween: 8,
      slidesPerView: 5,
      slidesPerGroup: 5
    }
  },
});

// custom pdp ETA check start

const PDP_INVENTORY_API_URL = 'https://app.xyxxcrew.com/xyxx-apparels_laravel/public/api/productinventoryapi';

// The product that window.pdpInventoryData belongs to (or is currently
// loading for). Stored as a plain numeric id so "123" and
// "gid://shopify/Product/123" compare as equal.
let pdpInventoryProductId = null;

/**
 * Product currently on screen. The product form's hidden "product-id" input
 * sits inside the area the theme swaps on a product switch, so it always
 * reflects the NEW product; #pdp-inventory-data is the fallback.
 */
function getCurrentProductId() {
  const formInput = document.querySelector('form.custom-pdp-inv-form input[name="product-id"]');
  if (formInput && formInput.value) return formInput.value;

  const el = document.getElementById('pdp-inventory-data');
  return el && el.dataset.productId ? el.dataset.productId : null;
}

/**
 * Fetches inventory for ONE product and keeps window.pdpInventoryData /
 * window.pdpInventoryDataPromise pointing at it.
 *  - Same product already loaded or loading -> reuses it (no duplicate call).
 *  - Different product -> clears the old data straight away, so the previous
 *    product's stock can never be read, then fetches the new one.
 *  - If the shopper switches again before a response arrives, the late
 *    response is ignored.
 */
function loadPdpInventory(productId) {
  if (!productId) return Promise.resolve(null);

  const numericId = extractNumericId(productId);

  if (numericId === pdpInventoryProductId && window.pdpInventoryDataPromise) {
    return window.pdpInventoryDataPromise;
  }

  pdpInventoryProductId = numericId;
  window.pdpInventoryData = null;

  // Store the Promise so other scripts can await inventory data.
  const request = fetch(PDP_INVENTORY_API_URL, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      product_id: productId
    }),
    redirect: 'follow'
  })
    .then((response) => {
      if (!response.ok) {
        throw new Error('Inventory API request failed: ' + response.status);
      }

      return response.json();
    })
    .then((inventoryData) => {
      if (pdpInventoryProductId === numericId) {
        window.pdpInventoryData = inventoryData;
        console.log('PDP Inventory:', inventoryData);
      }
      return inventoryData;
    })
    .catch((error) => {
      console.error('PDP inventory error:', error);
      if (pdpInventoryProductId === numericId) {
        window.pdpInventoryData = null;
        pdpInventoryProductId = null; // allow a retry on the next check
      }
      return null;
    });

  window.pdpInventoryDataPromise = request;
  return request;
}

// Initial page load — same behaviour as before.
document.addEventListener('DOMContentLoaded', function () {
  const inventoryElement = document.getElementById('pdp-inventory-data');
  if (!inventoryElement) return;

  const productId = inventoryElement.dataset.productId;
  if (!productId) return;

  loadPdpInventory(productId);
});

// Product switch (product swatch / tab panel). The theme swaps the product
// section via AJAX and then fires 'pdp-productlist:init'. The inventory
// fetched on page load belongs to the PREVIOUS product, so fetch the new
// product's inventory now. Skipped when the pincode checker is off for the
// new product, since that data would never be used.
document.addEventListener('pdp-productlist:init', () => {
  const variantSelects = document.querySelector('variant-selects.custom-pdp-variants-selects');
  if (!variantSelects || variantSelects.getAttribute('data-pincode-checker') !== 'true') return;

  loadPdpInventory(getCurrentProductId());
});

document.addEventListener('DOMContentLoaded', () => {
  let etaCheckConfirmed = false;

  document.addEventListener('submit', (event) => {
    const form = event.target.closest('form.custom-pdp-inv-form');
    if (!form) return;

    // Toggle: only run this whole flow when enabled via
    // <variant-selects class="custom-pdp-variants-selects" data-pincode-checker="true">
    const variantSelects = document.querySelector('variant-selects.custom-pdp-variants-selects');
    const pincodeCheckerEnabled = variantSelects && variantSelects.getAttribute('data-pincode-checker') === 'true';
    if (!pincodeCheckerEnabled) return; // do nothing — default PDP flow runs as-is

    if (etaCheckConfirmed) return; // our own re-submit after confirm — let it through

    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();

    const submitBtn = form.querySelector('[type="submit"]');
    if (submitBtn) submitBtn.disabled = true;

    // Read the CURRENTLY selected variant id live, at click time — this is
    // what makes it correct after a variant change without any extra
    // change-listener bookkeeping. Dawn/OS2.0 themes keep this in sync via
    // the form's own hidden "id" input whenever the customer picks a
    // different option (color/size/etc.).
    const getCurrentVariantId = () => {
      const input = form.querySelector('input[name="id"]');
      return input ? input.value : null;
    };

    const proceedWithPincode = async (pincode) => {
      // Make sure the inventory loaded belongs to the product currently on
      // screen (a no-op when it already does), then wait for it to resolve.
      const currentProductId = getCurrentProductId();
      if (currentProductId) {
        await loadPdpInventory(currentProductId);
      } else if (window.pdpInventoryDataPromise) {
        await window.pdpInventoryDataPromise;
      }

      const variantId = getCurrentVariantId();
      const result = checkLocalPickupAvailability(pincode, variantId);

      showAvailabilityModal(
        result,
        pincode,
        async (confirmed) => {
          if (submitBtn) submitBtn.disabled = false;
          if (!confirmed) return; // Cancelled: do nothing.
          if (result.status !== 'available' && result.status !== 'normal_delivery') return;

          // Quantity cap: don't let the customer add more of this variant
          // than the SERVING location actually has, counting only what's
          // already in the cart FROM THAT SAME location.
          if (typeof result.availableQuantity === 'number') {
            const requestedQty = parseInt(new FormData(form).get('quantity') || '1', 10);
            const existingQty = await getCartQuantityForVariant(variantId, result.locationZip);

            if (existingQty + requestedQty > result.availableQuantity) {
              showQuantityLimitModal(pincode);
              return; // block — nothing added
            }
          }

          setEtaLineItemProperty(form, result.eta);
          setPincodeLineItemProperty(form, pincode);
          setLocationLineItemProperty(form, result.locationZip);
          setLocationIdLineItemProperty(form, result.locationId); 
          etaCheckConfirmed = true;
          if (form.requestSubmit) {
            form.requestSubmit();
          } else {
            form.submit();
          }
          etaCheckConfirmed = false;
        },
        () => {
          // "Change" clicked — reopen the pincode step, pre-filled, and re-check.
          showPincodeModal(
            (newPincode) => {
              setCachedPincode(newPincode);
              proceedWithPincode(newPincode);
            },
            () => {
              if (submitBtn) submitBtn.disabled = false;
            },
            pincode
          );
        }
      );
    };

    const cachedPincode = getCachedPincode();

    if (cachedPincode) {
      proceedWithPincode(cachedPincode);
    } else {
      showPincodeModal(
        (pincode) => {
          setCachedPincode(pincode);
          proceedWithPincode(pincode);
        },
        () => {
          if (submitBtn) submitBtn.disabled = false;
        }
      );
    }
  }, true); // capture phase — critical
});

/**
 * Pincode is cached in localStorage so it survives across page loads and
 * different products in the same browser.
 */
const PINCODE_CACHE_KEY = 'pdp_delivery_pincode';

function getCachedPincode() {
  try {
    return localStorage.getItem(PINCODE_CACHE_KEY);
  } catch (e) {
    return null;
  }
}

function setCachedPincode(pincode) {
  try {
    localStorage.setItem(PINCODE_CACHE_KEY, pincode);
  } catch (e) {
    // fail silently
  }
}

function setEtaLineItemProperty(form, eta) {
  const propertyName = 'properties[ETA]';
  const value = eta === '1 day' ? 'Express Delivery' : 'Normal Delivery';

  let input = form.querySelector(`input[name="${propertyName}"]`);
  if (!input) {
    input = document.createElement('input');
    input.type = 'hidden';
    input.name = propertyName;
    form.appendChild(input);
  }
  input.value = value;
}

function setPincodeLineItemProperty(form, pincode) {
  const propertyName = 'properties[Customer Pincode]';

  let input = form.querySelector(`input[name="${propertyName}"]`);
  if (!input) {
    input = document.createElement('input');
    input.type = 'hidden';
    input.name = propertyName;
    form.appendChild(input);
  }
  input.value = pincode;
}

/**
 * Tags the cart line with the WAREHOUSE zip that's actually fulfilling it
 * (not the customer's entered pincode — those can differ, e.g. several
 * customer pincodes routing to the same Haryana warehouse). This is what
 * lets the quantity cap be checked per-location instead of per-variant
 * globally: units already in the cart from one warehouse shouldn't count
 * against a different warehouse's stock.
 */
function setLocationLineItemProperty(form, locationZip) {
  const propertyName = 'properties[Fulfilling Location Zip]';

  let input = form.querySelector(`input[name="${propertyName}"]`);
  if (!input) {
    input = document.createElement('input');
    input.type = 'hidden';
    input.name = propertyName;
    form.appendChild(input);
  }
  input.value = locationZip || '';
}

function setLocationIdLineItemProperty(form, locationId) {
  const propertyName = 'properties[Fulfilling Location ID]';

  let input = form.querySelector(`input[name="${propertyName}"]`);
  if (!input) {
    input = document.createElement('input');
    input.type = 'hidden';
    input.name = propertyName;
    form.appendChild(input);
  }
  input.value = extractNumericId(locationId) || '';
}

/**
 * Shopify GIDs ("gid://shopify/ProductVariant/49040203251865") vs the plain
 * numeric id the theme's form uses ("49040203251865") — compare on the
 * trailing digits so either format matches correctly.
 */
function extractNumericId(gidOrId) {
  if (!gidOrId) return null;
  const match = String(gidOrId).match(/(\d+)$/);
  return match ? match[1] : String(gidOrId);
}

/**
 * "Express Inventory" data source — now reads from window.pdpInventoryData
 * (fetched from your inventory API on page load) instead of the Liquid
 * pdp-store-availability-data script tag. Finds the entry matching the
 * CURRENTLY SELECTED variant and converts its variant_locations into the
 * same { available, locationName, zip } shape the rest of the logic
 * already expects — so nothing downstream (checkLocalPickupAvailability,
 * checkDeliveryAvailability, estimateEtaDays) needs to change at all.
 */
// function getStoreAvailabilityData(variantId) {
//   const inventoryData = window.pdpInventoryData;
//   if (!inventoryData || !Array.isArray(inventoryData.variants)) return [];

//   const targetId = extractNumericId(variantId);
//   const variant = inventoryData.variants.find(
//     (v) => extractNumericId(v.variant_id) === targetId
//   );
//   if (!variant || !Array.isArray(variant.variant_locations)) return [];

//   // return variant.variant_locations.map((loc) => ({
//   //   available: (loc.available_quantity || 0) > 0,
//   //   quantity: loc.available_quantity || 0,
//   //   locationName: loc.location_title,
//   //   zip: loc.location_address ? loc.location_address.zip : null,
//   // }));
//   return variant.variant_locations.map((loc) => ({
//   locationId: loc.location_id || null,
//   available: (loc.available_quantity || 0) > 0,
//   quantity: loc.available_quantity || 0,
//   locationName: loc.location_title,
//   zip: loc.location_address ? loc.location_address.zip : null,
// }));
// }
function getStoreAvailabilityData(variantId) {
  const inventoryData = window.pdpInventoryData;
  if (!inventoryData || !Array.isArray(inventoryData.variants)) return [];

  const targetId = extractNumericId(variantId);

  const variant = inventoryData.variants.find(
    (v) => extractNumericId(v.variant_id) === targetId
  );

  if (!variant || !Array.isArray(variant.variant_locations)) return [];

  return variant.variant_locations.map((loc) => ({
    locationId: loc.location_id || null,
    available: (loc.available_quantity || 0) > 0,
    quantity: loc.available_quantity || 0,
    locationName: loc.location_title,
    zip: loc.location_address
      ? loc.location_address.zip
      : null
  }));
}

function findNormalWarehouse(availableStores, customerZip) {
  if (!availableStores.length) {
    return null;
  }

  const expressLocations = getExpressLocationsData() || [];

  const expressLocationIds = new Set(
    expressLocations
      .map((location) => location.locationId)
      .filter(Boolean)
  );

  // Everything not configured as Express is Normal.
  const normalStores = availableStores.filter(
    (store) => !expressLocationIds.has(store.locationId)
  );

  if (!normalStores.length) {
    return null;
  }

  /*
   * Find the Normal warehouse with the shortest ETA.
   */
  let bestStore = null;
  let bestRank = Infinity;

  for (const store of normalStores) {
    const etaDays = estimateEtaDays(store.zip, customerZip);

    if (!etaDays) continue;

    const rank = parseInt(
      String(etaDays).split('-')[0],
      10
    );

    if (rank < bestRank) {
      bestRank = rank;
      bestStore = store;
    }
  }

  return bestStore;
}

// function findNormalWarehouse(availableStores) {
//   if (!availableStores.length) {
//     return null;
//   }

//   /*
//    * Prefer the Surat/Normal warehouse first.
//    *
//    * If later you have multiple Normal warehouses,
//    * this can be expanded to use their location IDs.
//    */
//   const suratStore = availableStores.find(
//     (store) => store.zip === '395010'
//   );

//   if (suratStore) {
//     return suratStore;
//   }

//   /*
//    * Otherwise use any other available Normal warehouse.
//    *
//    * This allows future Normal warehouses such as Mumbai
//    * to work automatically.
//    */
//   return availableStores.find(
//     (store) => store.zip !== '122505'
//   ) || null;
// }

function getExpressLocationsData() {
  const el = document.getElementById('pdp-availabile-pincode-data');
  if (!el) return null;
  try {
    const data = JSON.parse(el.textContent);
    return Array.isArray(data.express) ? data.express : null;
  } catch (e) {
    console.error('Could not parse serviceable pincode data', e);
    return null;
  }
}

/**
 * Looks through data.express[] for an entry whose "pincodes" array
 * contains the customer's pincode.
 * Returns { name, locationId, pincodes } for the matching express
 * location, or null if not found / no data available.
 */
function findExpressLocationForPincode(customerZip) {
  const expressLocations = getExpressLocationsData();
  if (!expressLocations) return null;

  return (
    expressLocations.find(
      (loc) => Array.isArray(loc.pincodes) && loc.pincodes.includes(customerZip)
    ) || null
  );
}

function estimateEtaDays(warehouseZip, customerZip) {
  if (!warehouseZip || !customerZip || customerZip.length !== 6) return null;
  if (warehouseZip === customerZip) return '1';
  if (warehouseZip.slice(0, 3) === customerZip.slice(0, 3)) return '1';
  if (warehouseZip.slice(0, 2) === customerZip.slice(0, 2)) return '2';
  if (warehouseZip.slice(0, 1) === customerZip.slice(0, 1)) return '3-4';
  return '5-6';
}

function checkLocalPickupAvailability(customerZip, variantId) {
  const matchedExpressLocation = findExpressLocationForPincode(customerZip);
  const stores = getStoreAvailabilityData(variantId);

  const availableStores = stores.filter(
    (store) => store.available && store.quantity > 0
  );

  /*
   * ============================================================
   * 1. EXPRESS PINCODE
   * ============================================================
   *
   * Example:
   * 122505 -> Haryana
   *
   * First check ONLY the mapped Express warehouse.
   *
   * If Express has inventory:
   *   -> Express Delivery
   *
   * If Express has no inventory:
   *   -> Check Normal warehouse(s)
   */


if (matchedExpressLocation) {
  const expressStore = stores.find(
    (store) =>
      extractNumericId(store.locationId) ===
      extractNumericId(matchedExpressLocation.locationId)
  );

  // Express inventory available
  if (
    expressStore &&
    expressStore.available &&
    expressStore.quantity > 0
  ) {
    return {
      status: 'available',

      // IMPORTANT:
      // If the customer pincode is explicitly configured
      // under an Express location, treat it as Express.
      eta: '1 day',

      warehouse: expressStore.locationName,
      availableQuantity: expressStore.quantity,
      locationZip: expressStore.zip,
      locationId: expressStore.locationId,
      expressLocationName: matchedExpressLocation.name
    };
  }

  // Express warehouse has no inventory.
  // Fall back to Normal delivery.
  const normalStore = findNormalWarehouse(
    availableStores,
    customerZip
  );

  if (normalStore) {
    const etaDays = estimateEtaDays(
      normalStore.zip,
      customerZip
    );

    return {
      status: 'normal_delivery',
      eta: etaDays ? `${etaDays} days` : '4-6 days',
      warehouse: normalStore.locationName,
      availableQuantity: normalStore.quantity,
      locationId: normalStore.locationId,
      locationZip: normalStore.zip
    };
  }

  return {
    status: 'not_serviceable'
  };
}  
  // if (matchedExpressLocation) {
  //   const expressStore = stores.find(
  //     (store) => store.locationId === matchedExpressLocation.locationId
  //   );

  //   // Express inventory available
  //   if (expressStore && expressStore.available && expressStore.quantity > 0) {
  //     const etaDays = estimateEtaDays(
  //       expressStore.zip,
  //       customerZip
  //     );

  //     return {
  //       status: 'available',
  //       eta: etaDays === '1' ? '1 day' : `${etaDays} days`,
  //       warehouse: expressStore.locationName,
  //       availableQuantity: expressStore.quantity,
  //       locationZip: expressStore.zip,
  //       locationId: expressStore.locationId, 
  //       expressLocationName: matchedExpressLocation.name
  //     };
  //   }

  //   /*
  //    * Express warehouse has NO inventory.
  //    *
  //    * Now fallback to Normal warehouse(s).
  //    */

  //   // const normalStore = findNormalWarehouse(availableStores);
  //   const normalStore = findNormalWarehouse(availableStores,customerZip);

  //   if (normalStore) {
  //     const etaDays = estimateEtaDays(
  //       normalStore.zip,
  //       customerZip
  //     );

  //     return {
  //       status: 'normal_delivery',
  //       eta: etaDays ? `${etaDays} days` : '4-6 days',
  //       warehouse: normalStore.locationName,
  //       availableQuantity: normalStore.quantity,
  //       locationId: normalStore.locationId,
  //       locationZip: normalStore.zip
  //     };
  //   }

  //   // Neither Express nor Normal has inventory
  //   return {
  //     status: 'not_serviceable'
  //   };
  // }


  /*
   * ============================================================
   * 2. NON-EXPRESS PINCODE
   * ============================================================
   *
   * Example:
   * 395010 -> Normal
   * 400059 -> Normal
   * 380060 -> Normal
   *
   * Any pincode that is NOT mapped to an Express location
   * should check Normal warehouse(s).
   *
   * DO NOT check Express inventory here.
   */

  // const normalStore = findNormalWarehouse(availableStores);
  const normalStore = findNormalWarehouse(
  availableStores,
  customerZip
);

  if (normalStore) {
    const etaDays = estimateEtaDays(
      normalStore.zip,
      customerZip
    );

    return {
      status: 'normal_delivery',
      eta: etaDays ? `${etaDays} days` : '4-6 days',
      warehouse: normalStore.locationName,
      availableQuantity: normalStore.quantity,
      locationId: normalStore.locationId,
      locationZip: normalStore.zip
    };
  }

  /*
   * No Normal warehouse has inventory.
   */
  return {
    status: 'not_serviceable'
  };
}
// function checkLocalPickupAvailability(customerZip, variantId) {
//   const expressLocations = getExpressLocationsData();
//   const matchedExpressLocation = findExpressLocationForPincode(customerZip);
//   const stores = getStoreAvailabilityData(variantId);
//   const availableStores = stores.filter(s => s.available);

//   // Check if customer pincode is in an express location's pincode list
//   const isNormalDeliveryPincode = !!matchedExpressLocation;
//   // Name of the matched express location (e.g. "Haryana", "Mumbai"),
//   // available whenever isNormalDeliveryPincode is true.
//   const matchedExpressLocationName = matchedExpressLocation ? matchedExpressLocation.name : null;

//   // Check if customer pincode itself exists in an available
//   // store/location from the current variant's inventory data
//   const isAvailableStorePincode = availableStores.some(
//     store => store.zip === customerZip
//   );

//   /*
//    * SPECIAL CASE:
//    *
//    * Pincode is NOT in an express location's pincode list
//    * BUT the same pincode exists in the current variant's inventory
//    * locations with available: true.
//    *
//    * Treat this as Normal Delivery.
//    */
//   if (!isNormalDeliveryPincode && isAvailableStorePincode) {
//     const servingStore = availableStores.find(store => store.zip === customerZip);
//     return {
//       status: 'normal_delivery',
//       eta: '4-6 days',
//       availableQuantity: servingStore ? servingStore.quantity : null,
//       warehouse: servingStore ? servingStore.locationName : null,
//       locationZip: servingStore ? servingStore.zip : null
//     };
//   }

//   /*
//    * SPECIAL CASE:
//    *
//    * Pincode IS in an express location's pincode list (e.g. Haryana's
//    * zone covers 122505, 122001, 123401) BUT this product's own
//    * inventory data only has exact in-stock zip(s) for some of those
//    * (e.g. just 122505, not 122001 or 123401).
//    *
//    * The express zone match alone isn't enough — this specific product
//    * isn't actually stocked at the customer's exact pincode, so treat
//    * it as not serviceable rather than falling back to a distance-based
//    * guess.
//    */
//   // if (isNormalDeliveryPincode && !isAvailableStorePincode) {
//   //   console.log("fsaffsf",isNormalDeliveryPincode,"fsaff",isAvailableStorePincode);
    
//   //   return {
//   //     status: 'not_serviceable'
//   //   };
//   // }

//   // Pincode matched an express location AND the product has exact
//   // in-stock inventory there — surface which one on the "available"
//   // result below via matchedExpressLocationName.

//   // If pincode is not in any express zone and is also not an available
//   // store pincode, it remains unserviceable.
//   if (expressLocations && !isNormalDeliveryPincode) {
//     console.log("daffdsf",expressLocations,"dsadsaf",isNormalDeliveryPincode);
//     return {
//       status: 'not_serviceable'
//     };
//   }

//   if (availableStores.length === 0) {
//     return {
//       status: 'unavailable'
//     };
//   }

//   // Existing ETA calculation
//   let best = null;

//   for (const store of availableStores) {
//     const etaDays = estimateEtaDays(store.zip, customerZip);

//     if (!etaDays) continue;

//     const rank = parseInt(etaDays.split('-')[0], 10);

//     if (!best || rank < best.rank) {
//       best = {
//         rank,
//         etaDays,
//         store
//       };
//     }
//   }

//   if (!best) {
//     return {
//       status: 'unavailable'
//     };
//   }

//   return {
//     status: 'available',
//     eta: best.etaDays === '1' ? '1 day' : `${best.etaDays} days`,
//     warehouse: best.store.locationName,
//     availableQuantity: best.store.quantity,
//     locationZip: best.store.zip,
//     expressLocationName: matchedExpressLocationName
//   };
// }

/**
 * Reads /cart.js and returns how many of this variant are ALREADY tied to
 * this SAME fulfilling location (via the "Fulfilling Location Zip" line
 * item property), not the variant's total quantity across every location.
 * Fails open (returns 0) if the cart can't be read, so a transient error
 * never blocks an otherwise-valid add.
 */
async function getCartQuantityForVariant(variantId, locationZip) {
  try {
    const res = await fetch('/cart.js');
    const cart = await res.json();
    const numericVariantId = Number(extractNumericId(variantId));

    return cart.items
      .filter((item) => {
        if (item.variant_id !== numericVariantId) return false;
        const itemLocationZip = item.properties && item.properties['Fulfilling Location Zip'];
        return itemLocationZip === locationZip;
      })
      .reduce((sum, item) => sum + item.quantity, 0);
  } catch (e) {
    console.error('Could not read cart for quantity check', e);
    return 0;
  }
}

/**
 * Small message-only modal shown when the customer's requested quantity
 * would exceed what the serving location actually has, factoring in what's
 * already in their cart. No Add to Cart action — just acknowledges and
 * closes, mirroring Shopify's native oversell message wording.
 */
function showQuantityLimitModal(pincode) {
  const existing = document.getElementById('eta-modal');
  if (existing) existing.remove();

  const modal = document.createElement('div');
  modal.id = 'eta-modal';
  modal.innerHTML = `
    <div class="eta-modal-overlay">
      <div class="eta-modal-box" role="dialog" aria-modal="true">
        <button id="eta-close" class="eta-modal-close" aria-label="Close">&times;</button>
        <p class="eta-modal-heading">Maximum quantity reached</p>
        <p class="eta-modal-subheading">The maximum quantity of this item is already in your cart.</p>
        <div class="eta-modal-actions">
          <button id="eta-cancel" class="btn btn-secondary">Okay</button>
        </div>
        <p class="eta-modal-pincode-line">
          Delivering to <strong>${pincode}</strong>
        </p>
      </div>
    </div>
  `;
  document.body.appendChild(modal);

  const close = () => modal.remove();
  document.getElementById('eta-close').addEventListener('click', close);
  document.getElementById('eta-cancel').addEventListener('click', close);
}

/**
 * Step 1 modal: pincode entry, shown inside the popup on Add to Cart click.
 */
function showPincodeModal(onCheck, onCancel, prefillPincode) {
  const existing = document.getElementById('eta-modal');
  if (existing) existing.remove();

  const modal = document.createElement('div');
  modal.id = 'eta-modal';
  modal.innerHTML = `
    <div class="eta-modal-overlay">
      <div class="eta-modal-box" role="dialog" aria-modal="true">
        <button id="eta-close" class="eta-modal-close" aria-label="Close">&times;</button>
        <p class="eta-modal-message">Enter your pincode to check delivery</p>
        <input
          type="text"
          id="modal-delivery-pincode"
          class="eta-modal-input"
          maxlength="6"
          inputmode="numeric"
          placeholder="e.g. 395010"
          autocomplete="postal-code"
          value="${prefillPincode || ''}"
        />
        <p id="eta-modal-error" class="eta-modal-error" style="display:none;">
          Please enter a valid 6-digit pincode
        </p>
        <div class="eta-modal-actions">
          <button id="eta-check-btn" class="btn btn-primary button">Check for Express Delivery</button>
        </div>
      </div>
    </div>
  `;
  document.body.appendChild(modal);

  const input = document.getElementById('modal-delivery-pincode');
  const errorMsg = document.getElementById('eta-modal-error');

  document.getElementById('eta-close').addEventListener('click', () => {
    modal.remove();
    onCancel();
  });

  document.getElementById('eta-check-btn').addEventListener('click', () => {
    const pincode = input.value.trim();
    if (!/^\d{6}$/.test(pincode)) {
      errorMsg.style.display = 'block';
      input.classList.add('input-error');
      input.focus();
      return;
    }
    modal.remove();
    onCheck(pincode);
  });

  input.addEventListener('keypress', (e) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      document.getElementById('eta-check-btn').click();
    }
  });

  input.focus();
  input.select();
}

/**
 * Step 2 modal: shows availability + ETA, with Add to Cart / Not Now.
 */
function showAvailabilityModal(result, pincode, onDecision, onChangePincode) {
  const existing = document.getElementById('eta-modal');
  if (existing) existing.remove();

  const isUnavailable = result.status === 'unavailable' || result.status === 'not_serviceable';
  const isNormalDelivery = result.status === 'normal_delivery' || (result.status === 'available' && result.eta !== '1 day');
  const isExpress = result.status === 'available' && result.eta === '1 day';

  let heading;
  let subheading;
  let confirmLabel;
  let confirmDisabled = false;
  let cancelLabel;

  if (isUnavailable) {
    console.log(result,"result");
    
    heading = "Sorry! Can't Service Now";
    texticon = '<svg class="not-servicable-icon" xmlns="http://www.w3.org/2000/svg" width="20px" height="20px" viewBox="0 0 24 24" fill="none"><path d="M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z" stroke="#323232" stroke-width="2"/><path d="M12 8L12 13" stroke="#323232" stroke-width="2" stroke-linecap="round"/><path d="M12 16V15.9888" stroke="#323232" stroke-width="2" stroke-linecap="round"/></svg>';
    subheading = 'Please check for another color';
    confirmLabel = 'Not Deliverable';
    confirmDisabled = true;
    cancelLabel = 'Check for other color';

  } else if (isExpress) {
    heading = 'Express Delivery Available for this product';
    texticon = '<svg class="express-servicable-icon" xmlns="http://www.w3.org/2000/svg" width="20px" height="20px" viewBox="0 0 15 15" fill="none"> <path fill-rule="evenodd" clip-rule="evenodd" d="M8.69666 0.040354C8.90859 0.131038 9.03105 0.354856 8.99315 0.582235L8.09019 6.00001H12.4999C12.6893 6.00001 12.8625 6.10701 12.9472 6.2764C13.0318 6.44579 13.0136 6.6485 12.8999 6.8L6.89997 14.8C6.76166 14.9844 6.5152 15.0503 6.30327 14.9596C6.09134 14.869 5.96888 14.6451 6.00678 14.4178L6.90974 8.99999H2.49999C2.31061 8.99999 2.13747 8.89299 2.05278 8.7236C1.96808 8.55421 1.98636 8.3515 2.09999 8.2L8.09996 0.200037C8.23827 0.0156255 8.48473 -0.0503301 8.69666 0.040354ZM3.49999 8H7.49996C7.64694 8 7.78647 8.06466 7.88147 8.17681C7.97647 8.28895 8.01732 8.43722 7.99316 8.58219L7.33026 12.5596L11.4999 7H7.49996C7.35299 7 7.21346 6.93534 7.11846 6.82319C7.02346 6.71105 6.98261 6.56278 7.00677 6.41781L7.66967 2.44042L3.49999 8Z" fill="#000000"/></svg>';
    subheading =
      document.body.getAttribute('data-express-delivery') ||
      'Delivery within 24 hours';
    confirmLabel = 'Add to Cart';
    cancelLabel = "I'll add later";

  } else if (isNormalDelivery) {
    heading = 'Sorry! Inventory Not available for Express Delivery';
    texticon = '<svg class="normal-servicable-icon" fill="#000000"  width="20" height="15" viewBox="0 0 20 15" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M1.1375 0C0.514062 0 0 0.514062 0 1.1375V11.6C0 12.2641 0.535938 12.8 1.2 12.8H2.8375C3.02813 13.9344 4.01406 14.8 5.2 14.8C6.38594 14.8 7.37188 13.9344 7.5625 12.8H11.2625C11.5578 12.8 11.8219 12.675 12.025 12.4875C12.2328 12.6703 12.4984 12.7969 12.8 12.8H13.2375C13.4281 13.9344 14.4141 14.8 15.6 14.8C16.9203 14.8 18 13.7203 18 12.4C18 11.0797 16.9203 10 15.6 10C14.4141 10 13.4281 10.8656 13.2375 12H12.8C12.725 12 12.6109 11.9484 12.525 11.8625C12.4391 11.7766 12.4 11.6734 12.4 11.6V4C12.4 3.85 12.65 3.6 12.8 3.6H16C16.3141 3.6 16.7562 3.93594 17.0625 4.3C17.0656 4.30469 17.0719 4.30781 17.075 4.3125L17.1375 4.4H15.2C14.5625 4.4 14 4.91563 14 5.6V7.2C14 7.53281 14.15 7.825 14.3625 8.0375C14.575 8.25 14.8672 8.4 15.2 8.4H19.2V11.6C19.2 11.75 18.95 12 18.8 12H18V12.8H18.8C19.4641 12.8 20 12.2641 20 11.6V7.75C20 6.83438 19.3625 6.025 19.3625 6.025H19.35L17.7 3.825V3.8125L17.6875 3.8C17.3187 3.35469 16.7656 2.8 16 2.8H12.8C12.6578 2.8 12.5266 2.82969 12.4 2.875V1.1625C12.4 0.548438 11.9156 0 11.275 0H1.1375ZM1.1375 0.8H11.275C11.4469 0.8 11.6 0.965625 11.6 1.1625V11.6625C11.6 11.85 11.4516 12 11.2625 12H7.5625C7.37188 10.8656 6.38594 10 5.2 10C4.01406 10 3.02813 10.8656 2.8375 12H1.2C1.05 12 0.8 11.7484 0.8 11.6V1.1375C0.8 0.95 0.946875 0.8 1.1375 0.8ZM15.2 5.2H17.7375L18.7125 6.5C18.7125 6.5 19.075 7.12031 19.15 7.6H15.2C15.1328 7.6 15.025 7.55 14.9375 7.4625C14.85 7.375 14.8 7.26719 14.8 7.2V5.6C14.8 5.39844 15.0375 5.2 15.2 5.2ZM5.2 10.8C6.08906 10.8 6.8 11.5109 6.8 12.4C6.8 13.2891 6.08906 14 5.2 14C4.31094 14 3.6 13.2891 3.6 12.4C3.6 11.5109 4.31094 10.8 5.2 10.8ZM15.6 10.8C16.4891 10.8 17.2 11.5109 17.2 12.4C17.2 13.2891 16.4891 14 15.6 14C14.7109 14 14 13.2891 14 12.4C14 11.5109 14.7109 10.8 15.6 10.8Z" fill="black"/> </svg>';
    subheading = document.body.getAttribute('data-normal-delivery') || `Delivery in ${result.eta}`;
    confirmLabel = 'Proceed with Normal Delivery';
    cancelLabel = "I'll add later";
  }

  const headingClass = isUnavailable ? 'unavailable'  : isExpress ? 'express' : isNormalDelivery ? 'normal-delivery' : '';

  const modal = document.createElement('div');
  modal.id = 'eta-modal';
  modal.innerHTML = `
    <div class="eta-modal-overlay">
      <div class="eta-modal-box ${headingClass}" role="dialog" aria-modal="true">
        <button id="eta-close" class="eta-modal-close" aria-label="Close">&times;</button>
        <div class="custom-heading-wrapper ${headingClass}">
        <p class="eta-modal-heading ${headingClass}"> <span class="custom-warn-icon ${headingClass}">${texticon}</span> ${heading}</p>
        ${subheading ? `<p class="eta-modal-subheading ${headingClass}">${subheading}</p>` : ''}
        </div>
        <div class="eta-modal-actions">
          <button id="eta-confirm" class="btn btn-primary button" ${confirmDisabled ? 'disabled' : ''}>
            ${confirmLabel}
          </button>
          <button id="eta-cancel" class="btn btn-secondary">${cancelLabel}</button>
        </div>
        <p class="eta-modal-pincode-line">
          Delivering to <strong>${pincode}</strong>
          <button type="button" id="eta-change-pincode" class="eta-modal-change-link">Change</button>
        </p>
      </div>
    </div>
  `;
  document.body.appendChild(modal);

  document.getElementById('eta-close').addEventListener('click', () => {
    modal.remove();
    onDecision(false);
  });

  document.getElementById('eta-cancel').addEventListener('click', () => {
    modal.remove();
    onDecision(false);
  });

  document.getElementById('eta-change-pincode').addEventListener('click', () => {
    modal.remove();
    onChangePincode();
  });

  const confirmBtn = document.getElementById('eta-confirm');
  if (confirmBtn && !confirmDisabled) {
    confirmBtn.addEventListener('click', () => {
      modal.remove();
      onDecision(true);
    });
  }
}
// custom pdp ETA check end



document.addEventListener('click', function (event) {
  const button = event.target.closest('.lab_btn');

  if (!button) return;

  const target = document.querySelector('#trust-stats');

  if (!target) return;

  event.preventDefault();

  target.scrollIntoView({
    behavior: 'smooth',
    block: 'center'
  });
});
// Run once in case it's already loaded
setNectorAlt();

// Watch for it being added/changed later
const observer = new MutationObserver(setNectorAlt);
observer.observe(document.body, {
  childList: true,
  subtree: true,
  attributes: true,
  attributeFilter: ['src', 'class']
});


const recommendationObserver = new MutationObserver((mutations) => {
    mutations.forEach(mutation => {
        mutation.addedNodes.forEach(node => {
            if (!(node instanceof HTMLElement)) return;
            if (node.matches?.("[js-recommendation-card]")) {
                window.initRecommendationCards(node.closest("product-recommendations"));
            }
            node.querySelectorAll?.("[js-recommendation-card]").forEach(card => {
                window.initRecommendationCards(card.closest("product-recommendations"));
            });
        });
    });
});

recommendationObserver.observe(document.body, {
    childList: true,
    subtree: true
});

window.initRecommendationCards = function (container = document) {
  if(!container) return;
  container.querySelectorAll("[js-recommendation-card]").forEach(card => {

    if (card.dataset.initialized) return;
    card.dataset.initialized = "true";

    // First available size

    const firstAvailable = card.querySelector(
      ".recommendation-card__size:not(.recommendation-card__size--sold-out)"
    );

    const variantInput = card.querySelector(".product-variant-id");
    const button = card.querySelector(".quick-add__submit");

    if (firstAvailable) {
      firstAvailable.classList.add("active");
      if (!variantInput) return;
      variantInput.value = firstAvailable.dataset.variantId;
      button.disabled = false;
      button.querySelector("span").textContent = "Add to cart";
    } else {
      button.disabled = true;
      button.querySelector("span").textContent = "Sold out";
    }

    const activeSwatch = card.querySelector('.recommendation-card__swatch[aria-current="true"]');

    if (activeSwatch) {
      activeSwatch.classList.add("active");
    }

  });

};


document.addEventListener('DOMContentLoaded', function () {
  const backToTop = document.getElementById('back-to-top');

  if (!backToTop) return;

  const scrollTrigger = 1200;
  let ticking = false;

  function updateBackToTop() {
    const scrollY = window.scrollY || window.pageYOffset;

    if (scrollY > scrollTrigger) {
      backToTop.classList.add('is-visible');
      backToTop.setAttribute('aria-hidden', 'false');
    } else {
      backToTop.classList.remove('is-visible');
      backToTop.setAttribute('aria-hidden', 'true');
    }
    ticking = false;
  }

  function handleScroll() {
    if (!ticking) {
      window.requestAnimationFrame(updateBackToTop);
      ticking = true;
    }
  }

  function scrollToTop() {
    const prefersReducedMotion = window.matchMedia(
      '(prefers-reduced-motion: reduce)'
    ).matches;

    window.scrollTo({
      top: 0,
      behavior: prefersReducedMotion ? 'auto' : 'smooth'
    });
  }

  window.addEventListener('scroll', handleScroll, {
    passive: true
  });

  backToTop.addEventListener('click', scrollToTop);

  // Set initial state
  updateBackToTop();
});

// show +more swatches start // 
if (document.querySelector('[js-show-more-product-options]')) {
  document.addEventListener('click', function (e) {
    const button = e.target.closest('[js-show-more-product-options]');
    
    if (!button) return;

    const parent = button.closest('[js-grid-product_options]');
    button.style.display = 'none';
    parent.querySelectorAll('[js-collection-product-option]').forEach(function (option) {
      option.style.display = 'inline-block';
      if (option.classList.contains('hidden')) {
        option.classList.remove('hidden');
      }
    });
  });
}
// show +more swatches end // 

// custom PDP related products //
document.addEventListener("click", function (e) {

    const swatch = e.target.closest(".recommendation-card__swatch");
    if (!swatch) return;

    const card = swatch.closest("[js-recommendation-card]");
    const data = JSON.parse(card.querySelector(".recommendation-card-json").textContent);
    const product = data.siblings.find(p => p.id == swatch.dataset.productId);
    card.currentProduct = product;

    if (!product) return;

    card.querySelectorAll(".recommendation-card__swatch").forEach(btn => {
      btn.setAttribute("aria-current", "false");
      btn.classList.remove("active");
    });
    swatch.setAttribute("aria-current", "true");
    swatch.classList.add("active");

    const image = card.querySelector(".recommendation-card-image");

      if (image) {
        image.src = product.featured_image;

        if ('srcset' in image) {
          image.srcset = product.featured_image;
        }
      }

    card.querySelector("[js-card-title] a").textContent = product.custom_title || product.title;
    card.querySelectorAll("a[js-card-link]").forEach(link=>{link.href = product.url;});

    const priceWrapper = card.querySelector("[js-card-price]");
    const price = Number(String(product.price).replace(/[^\d]/g, ""));
    const comparePrice = Number(String(product.compare_at_price || "").replace(/[^\d]/g, ""));
    const isOnSale = comparePrice > 0 && price > 0 && comparePrice > price;
    let savingsHtml = "";

    if (isOnSale) {
      const savings = Math.round(((comparePrice - price) / comparePrice) * 100);
      savingsHtml = `
        <span class="grid-product__price--savings">
          Save ${savings}%
        </span>
      `;
    }

    // Render price
    priceWrapper.innerHTML = isOnSale
      ? `
        <div class="price price--on-sale">
          <span class="price-item price-item--sale">
            ${product.price}
          </span>

          <span class="price-item price-item--regular grid-product__price--original">
            ${product.compare_at_price}
          </span>

          ${savingsHtml}
        </div>
      `
      : `
        <div class="price">
          <span class="price-item">
            ${product.price}
          </span>
        </div>
      `;

    const sizeWrap = card.querySelector("[js-card-sizes]");
    if (sizeWrap) {
      sizeWrap.innerHTML = "";
      product.variants.forEach((variant,index)=>{
          sizeWrap.insertAdjacentHTML("beforeend",`
              <button
                  type="button"
                  class="recommendation-card__size ${index==0 && variant.available ? "active":""}
                  ${variant.available ? "" : "recommendation-card__size--sold-out"}"
                  data-variant-id="${variant.id}"
                  ${variant.available ? "" : "disabled"}>
                  ${variant.size}
              </button>
          `);
      });
    }

    updateQuickAddState(card, product);
    const firstAvailable = product.variants.find(v=>v.available);
    if(firstAvailable){
        if (!card.querySelector(".product-variant-id")) return;
        card.querySelector(".product-variant-id").value = firstAvailable.id;
    }

});


  function updateQuickAddState(card, product) {
    const variantInput = card.querySelector(".product-variant-id");
    const addButton = card.querySelector(".quick-add__submit");
    if (!addButton) return;
    const buttonText = addButton.querySelector("span");
    const firstAvailable = product.variants.find(v => v.available);

    card.querySelectorAll(".recommendation-card__size").forEach(btn => {
      btn.classList.remove("active");
    });

    if (firstAvailable) {
      variantInput.value = firstAvailable.id;

      const activeBtn = card.querySelector(`.recommendation-card__size[data-variant-id="${firstAvailable.id}"]`);

      activeBtn?.classList.add("active");
      addButton.disabled = false;
      addButton.removeAttribute("disabled");
      addButton.removeAttribute("aria-disabled");
      buttonText.textContent = "Add to cart";
    } else {
      variantInput.value = "";
      addButton.disabled = true;
      addButton.setAttribute("disabled", "disabled");
      addButton.setAttribute("aria-disabled", "true");
      buttonText.textContent = "Sold out";
    }
  }

  document.addEventListener("click", function (e) {
    const swatchMore = e.target.closest("[js-show-more-product-options]");
    if (!swatchMore) return;

    swatchMore.classList.add("hidden");
    const listContainer = swatchMore.closest("[js-grid-product_options]");
    listContainer.querySelectorAll(".recommendation-card__swatch-item ").forEach((listitems) => {
      if (listitems.classList.contains("remaining-swatches")) {
        listitems.classList.remove("hidden");
      }
    })
  })

  document.addEventListener("click", function (e) {
    const sizeButton = e.target.closest(".recommendation-card__size");
    if (!sizeButton || sizeButton.disabled) return;

    const card = sizeButton.closest("[js-recommendation-card]");
    const variantInput = card.querySelector(".product-variant-id");
    const addButton = card.querySelector(".quick-add__submit");
    const buttonText = addButton?.querySelector("span");

    const variantId = Number(sizeButton.dataset.variantId);

    // Always set the form value first, regardless of whether product data is loaded
    if (variantInput) variantInput.value = variantId;

    card.querySelectorAll(".recommendation-card__size").forEach(btn => {
      btn.classList.remove("active");
      btn.setAttribute("aria-pressed", "false");
    });
    sizeButton.classList.add("active");
    sizeButton.setAttribute("aria-pressed", "true");

    // Determine availability from product data if we have it, otherwise trust the button itself
    const product = card.currentProduct;
    const variant = product?.variants.find(v => v.id === variantId);
    const isAvailable = variant ? variant.available : !sizeButton.classList.contains("recommendation-card__size--sold-out");

    if (!addButton) return;

    if (!isAvailable) {
      addButton.disabled = true;
      addButton.setAttribute("disabled", "disabled");
      addButton.setAttribute("aria-disabled", "true");
      if (buttonText) buttonText.textContent = "Sold out";
    } else {
      addButton.disabled = false;
      addButton.removeAttribute("disabled");
      addButton.removeAttribute("aria-disabled");
      if (buttonText) buttonText.textContent = "Add to cart";
    }
  });

  document.querySelectorAll("[js-recommendation-card]").forEach((card) => {

      const jsonEl = card.querySelector(".recommendation-card-json");
      if (jsonEl) {
        try {
          const data = JSON.parse(jsonEl.textContent);
          const current = card.querySelector('.recommendation-card__swatch[aria-current="true"]');
          const currentId = current?.dataset.productId;
          card.currentProduct = data.siblings.find(p => p.id == currentId) || data.siblings[0];
        } catch (err) {
          console.error("Could not parse recommendation card JSON", err);
        }
      }

    const current = card.querySelector('.recommendation-card__swatch[aria-current="true"]');
    if (current) {
      current.classList.add("active");
    }

    const firstAvailable = card.querySelector(".recommendation-card__size:not(.recommendation-card__size--sold-out)");
    const addButton = card.querySelector(".quick-add__submit");
    const variantInput = card.querySelector(".product-variant-id");

    if (!addButton || !variantInput) return;

    if (firstAvailable) {
      firstAvailable.classList.add("active");
      if (!variantInput) return;
      variantInput.value = firstAvailable.dataset.variantId;
      addButton.disabled = false;
      addButton.querySelector("span").textContent = "Add to cart";
    } else {
      variantInput.value = "";
      addButton.disabled = true;
      addButton.querySelector("span").textContent = "Sold out";
    }

  });
// custom PDP related products //


// collections grid filters
document.addEventListener("click", function (e) {
  const link = e.target.closest(".collection-grid-inline-filter__link");
  if (!link) return;

  e.preventDefault();

  fetch(link.href)
  .then((r) => r.text())
  .then((html) => {
    // Replace product grid
    document.querySelector("#ProductGridContainer").innerHTML =
      new DOMParser()
        .parseFromString(html, "text/html")
        .querySelector("#ProductGridContainer").innerHTML;

    // Replace native filters
    const doc = new DOMParser().parseFromString(html, "text/html");
    const facets = doc.querySelector("#main-collection-filters");

    if (facets) {
      document.querySelector("#main-collection-filters").innerHTML =
        facets.innerHTML;
    }

    history.pushState({}, "", link.href);

    // Update custom filter checkboxes
    const params = new URL(link.href).searchParams;
    const form = document.querySelector("#CustomFacetFiltersForm");

    if (form) {
      form.querySelectorAll('input[type="checkbox"]').forEach((input) => {
        input.checked = false;
      });

      params.forEach((value, key) => {
        const input = form.querySelector(`input[name="${CSS.escape(key)}"][value="${CSS.escape(value)}"]`);

        if (input) {
          input.checked = true;
        }
      });

      // Sync checkbox states + active classes
      FacetFiltersForm.syncAllFacetCheckboxes();
    }

    requestAnimationFrame(() => {
      window.initInfiniteScroll?.();
    });
  })
    .catch(console.error);
});
// collections grid filters


// filters search bar //
  function resetFilterSearch(details) {
    if (!details) return;

    var overlay = details.querySelector('.filter-search-overlay');
    var openBtn = details.querySelector('.filter-search-open-btn');
    var summaryLabel = details.querySelector('.custom-facets__summary-label');

    if (overlay) {
      overlay.classList.remove('active');

      var input = overlay.querySelector('.filter-search-input');
      if (input) input.value = '';
    }

    if (openBtn) {
      openBtn.classList.remove('hidden');
    }

    if (summaryLabel) {
      summaryLabel.classList.remove('hidden');
    }

    details
      .querySelectorAll('ul.list-unstyled > li.facets__item')
      .forEach(function (item) {
        item.style.display = '';
      });
  }

  document.addEventListener('click', function (e) {
    var openBtn = e.target.closest('.filter-search-open-btn');

    if (openBtn) {
      var details = openBtn.closest('details');
      if (!details || !details.open) return;

      var overlay = details.querySelector('.filter-search-overlay');
      var summaryLabel = details.querySelector('.custom-facets__summary-label');

      if (!overlay) return;

      overlay.classList.add('active');
      openBtn.classList.add('hidden');

      if (summaryLabel) {
        summaryLabel.classList.add('hidden');
      }

      var input = overlay.querySelector('.filter-search-input');
      if (input) {
        input.value = '';
        input.focus();
      }
      return;
    }

    var closeBtn = e.target.closest('.filter-search-close-btn');
    if (closeBtn) {
      resetFilterSearch(closeBtn.closest('details'));
    }
  });

  // Reset the search whenever a filter group (<details>) is closed
  document.addEventListener('toggle', function (e) {
    var details = e.target;
    if (!(details instanceof HTMLDetailsElement)) return;
    if (!details.closest('.js-filter')) return;
    if (!details.open) {
      resetFilterSearch(details);
    }
  }, true); // capture, since 'toggle' does not bubble

  document.addEventListener('input', function (e) {
    if (!e.target.classList.contains('filter-search-input')) return;
    var value = e.target.value.trim().toLowerCase();
    var details = e.target.closest('details');
    if (!details) return;
    details
      .querySelectorAll('ul.list-unstyled > li.facets__item')
      .forEach(function (item) {
        var label = item.querySelector('.facet-checkbox__text');
        if (!label) return;
        item.style.display = label.textContent.toLowerCase().includes(value) ? '' : 'none';
      });
  });
// filters search bar //


// PDP size-guide
document.addEventListener('click', (e) => {
  const popup = document.getElementById('size_guide_popup_open');
  if (!popup) return;

  // Open Size Guide
  if (e.target.closest('[js-size-guide]')) {
    popup.classList.add('active');
    popup.style.display = 'block';
    return;
  }

  // Close button
  if (e.target.closest('.closeBtn-pro')) {
    popup.classList.remove('active');
    popup.style.display = 'none';
    return;
  }

  // Size Guide Tabs
  if (
    e.target.matches(
      '.popup_size_guide_tab_title_1_new, .popup_size_guide_tab_title_2_new'
    )
  ) {
    e.preventDefault();

    const popupContent = e.target.closest('.popup-pro');
    if (!popupContent) return;

    popupContent.querySelectorAll('ul li a').forEach((tab) => {
      tab.classList.remove('active');
    });

    popupContent
      .querySelectorAll('.popup_size_guide_tab_details_in_new')
      .forEach((content) => {
        content.style.display = 'none';
      });

    e.target.classList.add('active');

    const isTab1 = e.target.classList.contains('popup_size_guide_tab_title_1_new');
    const content = popupContent.querySelector(
      isTab1 ? '.popup_size_guide_tab_1_new' : '.popup_size_guide_tab_2_new'
    );
    if (content) content.style.display = 'block';

    return;
  }

  // Close when clicking outside popup content (but inside the popup overlay)
  if (
    popup.classList.contains('active') &&
    popup.contains(e.target) &&
    !e.target.closest('.popup-content-pro')
  ) {
    popup.classList.remove('active');
    popup.style.display = 'none';
  }
});
// PDP size-guide

// PDP FAQs
function initPDPFAQs() {

  // Remove old listeners by cloning elements
  document.querySelectorAll(".FAQs_accordion_title_new").forEach((title) => {
    const newTitle = title.cloneNode(true);
    title.parentNode.replaceChild(newTitle, title);
  });

  // Add click events
  document.querySelectorAll(".FAQs_accordion_title_new").forEach((title) => {
    title.addEventListener("click", function () {
      const accordion = this.closest(".FAQs_accordion_new");
      const details = this.nextElementSibling;

      if (!this.classList.contains("active")) {

        // Close all items
        accordion.querySelectorAll(".FAQs_accordion_title_new").forEach((item) => {
          item.classList.remove("active");
        });

        accordion.querySelectorAll(".FAQs_accordion_details_new").forEach((item) => {
          item.style.display = "none";
          item.style.maxHeight = "0";
        });

        // Open current
        this.classList.add("active");
        details.style.display = "block";
        details.style.maxHeight = details.scrollHeight + "px";

      } else {

        // Close current
        this.classList.remove("active");
        details.style.maxHeight = "0";
        details.style.display = "none";
      }
    });
  });

  // Initial state
  document.querySelectorAll(".FAQs_accordion_list_new").forEach((item) => {
    const title = item.querySelector(".FAQs_accordion_title_new");
    const details = item.querySelector(".FAQs_accordion_details_new");

    if (title?.classList.contains("active")) {
      details.style.display = "block";
      details.style.maxHeight = details.scrollHeight + "px";
    } else {
      details.style.display = "none";
      details.style.maxHeight = "0";
    }
  });
}

// Initial load
initPDPFAQs();
// PDP FAQs


/**
 * PdpStockAlertSync
 * ---------------------------------------------------------------------------
 * 1) Adds a stock-state class to document.querySelector('[js-dd-main-product]'):
 *      .pdp-in-stock        selected size is available
 *      .pdp-out-of-stock    selected size is sold out
 *      (neither class)      no size selected yet
 *    Works on the landing page AND after every AJAX product switch, so your
 *    CSS can decide what to show (e.g. the Pragma "Notify me" widget).
 *
 * 2) Keeps the Pragma widget (#ia-embed-widget) alive across the switcher's
 *    innerHTML swap: capture() before, restore() after. The same node is put
 *    back (its listeners survive) and re-pointed at the new product's data.
 *
 * 3) After a switch it also drives the widget's own `ia-hidden` class:
 *      sold-out size  -> ia-hidden REMOVED (Notify button visible)
 *      in-stock size  -> ia-hidden ADDED   (hidden)
 *      no size yet    -> ia-hidden ADDED   (hidden)
 */
window.PdpStockAlertSync = (() => {
  'use strict';

  const WIDGET_ID = 'ia-embed-widget';
  const MAIN_SELECTOR = '[js-dd-main-product]';
  const CLASS_IN_STOCK = 'pdp-in-stock';
  const CLASS_OUT_OF_STOCK = 'pdp-out-of-stock';

  let widget = null;            // app's live widget node, kept across swaps
  let state = null;             // { handle, product: Promise|null, switched: bool }
  let desiredVariantId = null;  // widget data-variant-id we want to keep
  let desiredHidden = true;     // whether the widget should carry ia-hidden
  let observer = null;
  let listening = false;

  const escapeHtml = (value) => String(value ?? '').replace(/[&<>"']/g, (c) => (
    { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]
  ));

  const sized = (url) => (url ? `${url}${url.includes('?') ? '&' : '?'}width=400` : '');

  const handleFromUrl = () => (location.pathname.match(/\/products\/([^/?#]+)/) || [])[1] || null;

  /** Shopify AJAX Product API: title, image and live `available` per variant. */
  function loadProduct(handle) {
    return fetch(`/products/${encodeURIComponent(handle)}.js`, { credentials: 'same-origin' })
      .then((response) => {
        if (!response.ok) throw new Error(`Stock alert sync: HTTP ${response.status} for ${handle}`);
        return response.json();
      });
  }

  /** Variant for the sizes/options currently checked in the form. */
  function selectedVariant(product, root) {
    if (!root) return null;
    const picked = [];
    root.querySelectorAll('variant-selects input[type="radio"][data-option-name]:checked').forEach((input, i) => {
      const position = (input.name || '').trim().match(/-(\d+)$/);
      picked[position ? parseInt(position[1], 10) - 1 : i] = input.value;
    });

    const optionCount = product.variants[0]?.options.length || 0;
    if (optionCount && picked.length === optionCount && !picked.includes(undefined)) {
      return product.variants.find((v) => v.options.every((value, i) => value === picked[i])) || null;
    }

    // Fallback: the variant id Dawn writes into the form once a variant is resolved.
    const id = root.querySelector('input[name="id"]')?.value;
    return id ? product.variants.find((v) => String(v.id) === String(id)) || null : null;
  }

  /** The only visual state we own: classes on the main product section. */
  function setStockClasses(variant) {
    const root = document.querySelector(MAIN_SELECTOR);
    if (!root) return;
    const outOfStock = !!variant && variant.available === false;
    const inStock = !!variant && !outOfStock;
    root.classList.toggle(CLASS_IN_STOCK, inStock);
    root.classList.toggle(CLASS_OUT_OF_STOCK, outOfStock);
  }

  /** ia-hidden on the widget root: removed = visible, added = hidden. */
  function setWidgetHidden(hidden) {
    desiredHidden = hidden;
    if (!widget) return;
    widget.classList.toggle('ia-hidden', hidden);
    widget.style.display = hidden ? 'none' : 'block';
  }

  /** After a switch: re-point the widget's data + copy at the new product/variant. */
  function syncWidget(product, variant) {
    if (!widget) return;
    const ds = widget.dataset;

    ds.productId = String(product.id);
    ds.productTitle = product.title;
    ds.productHandle = product.handle;
    ds.initialVariantId = String(product.variants[0].id);
    ds.fallbackImage = sized(product.featured_image);

    const dataScript = widget.querySelector('script.ia-variant-data');
    if (dataScript) dataScript.textContent = JSON.stringify(product.variants);

    if (!variant) {
      desiredVariantId = null;
      setWidgetHidden(true);
      return;
    }

    const image = sized(variant.featured_image?.src || product.featured_image);
    ds.variantId = String(variant.id);
    ds.variantTitle = variant.title;
    ds.price = (variant.price / 100).toFixed(2);
    ds.productImage = image;
    desiredVariantId = String(variant.id);
    setWidgetHidden(variant.available !== false); // sold out => remove ia-hidden

    const label = `${product.title} (${variant.title})`;
    const description = widget.querySelector('.ia-description-text');
    if (description) {
      const template = widget.querySelector('.ia-desc-template')?.textContent
        || "We'll email you when **{product}** is back in stock.";
      description.innerHTML = escapeHtml(template)
        .replace(/\*\*\{product\}\*\*/g, `<strong>${escapeHtml(label)}</strong>`)
        .replace(/\{product\}/g, escapeHtml(label));
    }
    const img = widget.querySelector('.ia-product-img');
    if (img) img.src = image;

    // Clean slate for the modal when the shopper moves to another product.
    widget.querySelector('.ia-form')?.reset();
    widget.querySelectorAll('.ia-success-msg, .ia-error-msg, .ia-validation-error')
      .forEach((el) => el.classList.add('ia-hidden'));
  }

  /** Re-read the selection, refresh the classes (and the widget after a switch). */
  async function update() {
    if (!state) state = { handle: handleFromUrl(), product: null, switched: false };
    const current = state;
    if (!current.handle) return;

    current.product = current.product || loadProduct(current.handle);
    let product;
    try {
      product = await current.product;
    } catch (error) {
      current.product = null;
      console.warn(error);
      return;
    }
    if (state !== current) return; // switched again while loading

    const variant = selectedVariant(product, document.querySelector(MAIN_SELECTOR));
    setStockClasses(variant);
    if (current.switched) syncWidget(product, variant);
  }

  /** The app's stale tracking can flip ia-hidden / data-variant-id; keep ours. */
  function guardWidget() {
    if (observer) observer.disconnect();
    observer = new MutationObserver(() => {
      if (!widget || !state || !state.switched) return;
      if (widget.classList.contains('ia-hidden') !== desiredHidden) {
        widget.classList.toggle('ia-hidden', desiredHidden);
      }
      const display = desiredHidden ? 'none' : 'block';
      if (widget.style.display !== display) widget.style.display = display;
      if (desiredVariantId && widget.dataset.variantId !== desiredVariantId) {
        widget.dataset.variantId = desiredVariantId;
      }
    });
    observer.observe(widget, { attributes: true, attributeFilter: ['class', 'style', 'data-variant-id'] });
  }

  function listenForSelection() {
    if (listening) return;
    listening = true;
    // Delegated on document: survives every innerHTML swap.
    document.addEventListener('change', (event) => {
      if (event.target.closest?.('variant-selects')) update();
    });
  }

  // ---- public API ----------------------------------------------------------

  /** Call right BEFORE the switcher replaces the product form's markup. */
  function capture() {
    widget = document.getElementById(WIDGET_ID) || widget;
  }

  /** Call right AFTER the switcher replaced the markup. */
  function restore(container, handle) {
    if (!container || !handle) return;

    state = { handle, product: loadProduct(handle), switched: true };
    state.product.catch(() => {}); // surfaced in update()
    setStockClasses(null);         // nothing selected yet on the new product

    if (widget) {
      // If the fetched markup ever carries its own copy, drop it; keep the live one.
      container.querySelectorAll(`#${WIDGET_ID}`).forEach((node) => { if (node !== widget) node.remove(); });

      const host = container.querySelector('product-form .product-form__buttons')
        || container.querySelector('product-form form');
      if (host) {
        host.appendChild(widget); // same node => app listeners stay attached
        setWidgetHidden(true);    // nothing selected yet
        guardWidget();
      }
    }

    update(); // also covers the switcher re-selecting the previous size
  }

  listenForSelection(); // classes also work on the landing page

  return { capture, restore, update };
})();

/**
 * PdpTemplateSectionSync
 * ---------------------------------------------------------------------------
 * Makes the AJAX product switcher template-aware.
 *
 * When the target product is assigned to a different product template
 * (e.g. Secondary PDP -> Activewear PDP), this:
 *   1. fetches the target product page ONCE (Shopify renders it with the
 *      target's assigned template + the Theme Customizer settings saved for it),
 *   2. finds which "managed" sections exist there but not on the live page
 *      and inserts them in the right position,
 *   3. removes managed sections that the target template does not have,
 *   4. loads any theme CSS/JS those sections need that the current page
 *      never loaded, and revives <script> tags inside the inserted markup,
 *   5. runs each section's init hook.
 *
 * Everything else (main product swap, reviews, etc.) stays in your existing
 * ProductStitcher code.
 *
 * Liquid prerequisites (see answer):
 *   - [js-dd-main-product]          data-template-suffix="{{ product.template_suffix | default: 'default' }}"
 *   - each [js-dd-product-switcher] data-template-suffix="{{ p.template_suffix | default: 'default' }}"
 */
window.PdpTemplateSectionSync = (() => {
  'use strict';

  const MAIN_SELECTOR = '[js-dd-main-product]';

  /**
   * Sections that exist on SOME PDP templates but not all.
   * Add every section that differs between your templates.
   *   selector     - an element inside the section (used to find its
   *                  .shopify-section wrapper on both the live and target page)
   *   beforeRemove - teardown (destroy sliders, observers) before wrapper removal
   *   afterInsert  - init hook, runs one frame after the wrapper is in the DOM
   */
  const MANAGED_SECTIONS = [
    {
      key: 'trustStats',
      selector: '[product-trust-stats]',
      afterInsert: () => window.initTrustStats?.(),
    },
    {
      key: 'mediaCarousel',
      selector: '[js-dd-pdp-media-carousel]',
      beforeRemove: (wrapper) => window.PdpMediaCardCarousel?.destroyWithin?.(wrapper),
      afterInsert: (wrapper) => window.PdpMediaCardCarousel?.initWithin?.(wrapper),
    },
    {
      key: 'secondaryFaq',
      selector: '[js-dd-secondary-faq-section]',
      afterInsert: () => document.dispatchEvent(new CustomEvent('secondaryPDPFaqSection:init')),
    },
    {
      key: 'collapsibleContent',
      selector: '[js-dd-collapsible-content]',
    },
  ];

  // Optional: mimic the Theme Editor event for sections whose own JS listens
  // for it. Leave false if your sections are initialised via afterInsert.
  const FIRE_SECTION_LOAD_EVENT = false;

  const docCache = new Map(); // handle -> Promise<Document>
  let reconciledSuffix = null; // template the live sections currently match

  // ---- helpers -------------------------------------------------------------

  const absolute = (value) => new URL(value, location.href);
  const sameAsset = (a, b) => a.origin === b.origin && a.pathname === b.pathname;
  // Shopify theme assets live under .../assets/...; ignore analytics, apps, etc.
  const isThemeAsset = (url) => url.pathname.includes('/assets/');

  function productUrl(handle) {
    const url = new URL(`/products/${handle}`, location.origin);
    // Keep fetching from the same theme when previewing an unpublished theme.
    const preview = new URLSearchParams(location.search).get('preview_theme_id');
    if (preview) url.searchParams.set('preview_theme_id', preview);
    return url.toString();
  }

  /** Full page of the target product, parsed once and cached per handle. */
  function fetchProductDocument(handle) {
    if (!docCache.has(handle)) {
      const request = fetch(productUrl(handle), { credentials: 'same-origin' })
        .then((response) => {
          if (!response.ok) throw new Error(`Template sync: HTTP ${response.status} for ${handle}`);
          return response.text();
        })
        .then((html) => new DOMParser().parseFromString(html, 'text/html'))
        .catch((error) => {
          docCache.delete(handle); // don't cache failures
          throw error;
        });
      docCache.set(handle, request);
    }
    return docCache.get(handle);
  }

  function prefetch(handle) {
    if (handle) fetchProductDocument(handle).catch(() => {});
  }

  /** Map of wrapper-id -> .shopify-section wrapper that contains cfg.selector. */
  function collectWrappers(root, cfg) {
    const found = new Map();
    root.querySelectorAll(cfg.selector).forEach((el) => {
      const wrapper = el.closest('.shopify-section');
      if (!wrapper || !wrapper.id) return;
      // Never touch the wrapper that holds the product itself.
      if (wrapper.matches(MAIN_SELECTOR) || wrapper.querySelector(MAIN_SELECTOR)) return;
      found.set(wrapper.id, wrapper);
    });
    return found;
  }

  /** Load theme stylesheets/scripts the target page has but this page doesn't. */
  function loadMissingAssets(targetDoc) {
    const pending = [];
    // Resolve on load/error, or after 4s so a stuck asset can never block the swap.
    const settle = (el) => new Promise((resolve) => {
      el.onload = el.onerror = resolve;
      setTimeout(resolve, 4000);
    });

    const liveStyles = [...document.querySelectorAll('link[rel="stylesheet"][href]')]
      .map((l) => absolute(l.getAttribute('href')));
    targetDoc.querySelectorAll('link[rel="stylesheet"][href]').forEach((link) => {
      const url = absolute(link.getAttribute('href'));
      if (!isThemeAsset(url) || liveStyles.some((u) => sameAsset(u, url))) return;
      const el = document.createElement('link');
      el.rel = 'stylesheet';
      el.href = url.href;
      pending.push(settle(el));
      document.head.appendChild(el);
    });

    const liveScripts = [...document.scripts].filter((s) => s.src).map((s) => absolute(s.src));
    targetDoc.querySelectorAll('script[src]').forEach((script) => {
      const url = absolute(script.getAttribute('src'));
      if (!isThemeAsset(url) || liveScripts.some((u) => sameAsset(u, url))) return;
      const el = document.createElement('script');
      el.src = url.href;
      if (script.type === 'module') el.type = 'module';
      else el.async = false; // keep execution order
      pending.push(settle(el));
      document.head.appendChild(el);
    });

    return Promise.all(pending);
  }

  /** Scripts parsed by DOMParser (and cloned) never execute; rebuild them. */
  function reviveScripts(root) {
    root.querySelectorAll('script').forEach((old) => {
      const type = (old.getAttribute('type') || '').toLowerCase();
      // JSON blobs (application/json, ld+json, ...) are data, leave them.
      if (type && type !== 'module' && !type.includes('javascript')) return;

      if (old.src) {
        const url = absolute(old.src);
        const loaded = [...document.scripts].some((s) => s.src && sameAsset(absolute(s.src), url));
        if (loaded) {
          old.remove();
          return;
        }
      }
      const fresh = document.createElement('script');
      [...old.attributes].forEach((attr) => fresh.setAttribute(attr.name, attr.value));
      fresh.textContent = old.textContent;
      old.replaceWith(fresh);
    });
  }

  /**
   * Insert a wrapper from the target page at the same relative position:
   * after the nearest preceding section that also exists live, else before the
   * nearest following one, else right after the main product section.
   */
  function insertInOrder(targetWrapper) {
    const clone = document.importNode(targetWrapper, true);
    const siblings = [...targetWrapper.parentElement.querySelectorAll(':scope > .shopify-section')];
    const index = siblings.indexOf(targetWrapper);

    let anchor = null;
    let placeAfter = true;
    for (let i = index - 1; i >= 0 && !anchor; i--) anchor = document.getElementById(siblings[i].id);
    if (!anchor) {
      placeAfter = false;
      for (let i = index + 1; i < siblings.length && !anchor; i++) anchor = document.getElementById(siblings[i].id);
    }
    if (!anchor) {
      anchor = document.querySelector(MAIN_SELECTOR)?.closest('.shopify-section');
      placeAfter = true;
    }

    if (anchor) anchor[placeAfter ? 'after' : 'before'](clone);
    else (document.querySelector('main') || document.body).appendChild(clone);
    return clone;
  }

  // ---- public API ----------------------------------------------------------

  /**
   * @param {object} opts
   * @param {string} opts.handle        target product handle
   * @param {string|null} opts.targetSuffix  target's template suffix (from Liquid), or null if unknown
   * @param {Element|null} opts.mainSection  live [js-dd-main-product] element
   * @returns {Promise<{inserted:number, removed:number}>}
   */
  async function sync({ handle, targetSuffix = null, mainSection = null }) {
    const result = { inserted: 0, removed: 0 };

    if (reconciledSuffix === null) {
      reconciledSuffix = mainSection?.dataset.templateSuffix ?? null;
    }
    // Same template as the sections already on screen: nothing to do, no request.
    if (targetSuffix !== null && targetSuffix === reconciledSuffix) return result;

    let targetDoc;
    try {
      targetDoc = await fetchProductDocument(handle);
    } catch (error) {
      console.warn(error);
      return result;
    }

    const toInsert = [];
    const toRemove = [];
    MANAGED_SECTIONS.forEach((cfg) => {
      const live = collectWrappers(document, cfg);
      const wanted = collectWrappers(targetDoc, cfg);
      wanted.forEach((wrapper, id) => { if (!live.has(id)) toInsert.push({ cfg, wrapper }); });
      live.forEach((wrapper, id) => { if (!wanted.has(id)) toRemove.push({ cfg, wrapper }); });
    });

    // Remove first so they can't be picked as insertion anchors.
    toRemove.forEach(({ cfg, wrapper }) => {
      cfg.beforeRemove?.(wrapper);
      wrapper.remove();
      result.removed++;
    });

    if (toInsert.length) {
      await loadMissingAssets(targetDoc); // CSS/JS first, so custom elements upgrade correctly

      // Insert in the order they appear on the target page.
      toInsert.sort((a, b) =>
        a.wrapper.compareDocumentPosition(b.wrapper) & Node.DOCUMENT_POSITION_FOLLOWING ? -1 : 1
      );
      toInsert.forEach(({ cfg, wrapper }) => {
        const node = insertInOrder(wrapper);
        reviveScripts(node);
        requestAnimationFrame(() => {
          cfg.afterInsert?.(node);
          if (FIRE_SECTION_LOAD_EVENT) {
            node.dispatchEvent(new CustomEvent('shopify:section:load', {
              bubbles: true,
              detail: { sectionId: node.id.replace(/^shopify-section-/, '') },
            }));
          }
        });
        result.inserted++;
      });
    }

    reconciledSuffix = targetDoc.querySelector(MAIN_SELECTOR)?.dataset.templateSuffix ?? targetSuffix;
    return result;
  }

  return { sync, prefetch, MANAGED_SECTIONS };
})();

// secondary PDP
class ProductStitcher extends HTMLElement {


    playVisibleProductVideos(container = document) {
      const videos = container.querySelectorAll('.product__video');

      videos.forEach((video) => {
        try {
          video.muted = true;
          video.defaultMuted = true;
          video.setAttribute('muted', '');
          video.setAttribute('autoplay', '');
          video.setAttribute('playsinline', '');
          video.setAttribute('loop', '');

          // reload + play after ajax DOM swap
          video.load();

          const playPromise = video.play();
          if (playPromise !== undefined) {
            playPromise.catch((err) => {
              console.log('Video autoplay blocked:', err);
            });
          }
        } catch (e) {
          console.log('Video play error:', e);
        }
      });
    }

  constructor() {
      super();

      this.selectors = {
          mainSection: "[js-dd-main-product]",
          mainPDPInfoSection: "[js-dd-product-info]",
          productReviews: "[js-dd-nector-review]",
          productList: "[js--product-list]",
          productRecommendation: "[js-dd-product-recommendation]",
          stitcherItem: "[js-dd-product-switcher]",
          faqSection: "[js-dd-secondary-faq-section]",
          pdpAccordion: "[js-hb-faq-section]",
          collapsibleContent: "[js-dd-collapsible-content]",
          fabricDropdown: "fabric-dropdown",
          mobilefabricDropdown:  "mobile-fabric-dropdown",
          trustStats: "[product-trust-stats]",
          mediaCarousel: "[js-dd-pdp-media-carousel]" 
      };

      this.mainSection = this.closest(this.selectors.mainSection);
      
      this.sections = {
          mainProduct: { 
              element: this.mainSection, 
              selector: this.selectors.mainSection, 
              initEvents: ["size-guide:init", "product-features-accordion:init", "secondaryPDPSlider:init", "update-size-label2:init", "update-size-label:init"] 
          },
           productReviews: { 
               element: document.querySelector(this.selectors.productReviews), 
               selector: this.selectors.productReviews 
           },
           productList: { 
               element: document.querySelector(this.selectors.productList), 
               selector: this.selectors.productList,
               initEvents: ["pdp-productlist:init"]
           },
           productRecommendation: { 
               element: document.querySelector(this.selectors.productRecommendation), 
               selector: this.selectors.productRecommendation,
           },
          faqSection: { 
               element: document.querySelector(this.selectors.faqSection), 
               selector: this.selectors.faqSection,
               initEvents: ["secondaryPDPFaqSection:init"]
           },
          pdpAccordion: { 
               element: document.querySelector(this.selectors.pdpAccordion), 
               selector: this.selectors.pdpAccordion,
               initEvents: ["pdp-accordion:init"]
           },
           collapsibleContent: {
               element: document.querySelector(this.selectors.collapsibleContent),
               selector: this.selectors.collapsibleContent
           },
           trustStats: {
               element: document.querySelector(this.selectors.trustStats),
               selector: this.selectors.trustStats
           },
           mediaCarousel: {
              element: document.querySelector(this.selectors.mediaCarousel),
              selector: this.selectors.mediaCarousel
          }
      };

      this.stitcherItems = this.querySelectorAll(this.selectors.stitcherItem);
      this.fabricDropdowns = document.querySelectorAll(this.selectors.fabricDropdown);
      this.mobilefabricDropdowns = document.querySelectorAll(this.selectors.mobilefabricDropdown);

      // Force "nothing selected yet" on every construction of this element.
      // Because a fresh <product-stitcher> (and a fresh constructor() call)
      // is created both on the very first page load AND on every product
      // switch (see the note above bindSwitcherAvailabilityCheck), doing
      // this here — instead of only once on load — covers both cases with
      // one call. ajaxSection() runs afterwards (on the OLD instance) and,
      // if the shopper had explicitly picked a size on the product they're
      // switching FROM, re-clicks that size on the new markup, which
      // overrides this reset through the normal variant-select flow.
      this.resetVariantSelectionState(this.mainSection);

      this.init();
      this.bindSwitcherAvailabilityCheck();
  }

  // ---- Switcher availability check -------------------------------------
  // Disables (adds "is-disabled" to) any [js-dd-product-switcher] item whose
  // matching variant for the currently selected PDP options is missing or
  // sold out. Reuses the variant JSON product-stitcher already renders per
  // switcher item (script[js-product-json]) — no extra request.
  //
  // Anchored on this.mainSection rather than any node inside it, because
  // ajaxSection() (switcher click) does container.innerHTML = ajaxContainer
  // .innerHTML where container === this.mainSection: that node itself is
  // never destroyed, only its children (including this custom element) are.
  // A fresh <product-stitcher> — and a fresh constructor() call — is created
  // for every switcher click, so this method naturally reruns on load AND
  // after every switch. The dataset guard below stops the one persistent
  // change listener from being added again by each new instance.
  bindSwitcherAvailabilityCheck() {
      if (!this.mainSection) return;

      if (!this.mainSection.dataset.switcherAvailabilityBound) {
          this.mainSection.dataset.switcherAvailabilityBound = "true";
          this.mainSection.addEventListener("change", (e) => {
              if (e.target.matches('variant-selects input[type="radio"][data-option-name]')) {
                  this.updateSwitcherAvailability();
              }
          });
      }

      this.updateSwitcherAvailability();
  }

  // Selected option values in option1/option2/option3 order, read from
  // whichever radios are currently :checked (mirrors the existing Size
  // lookup used elsewhere in ajaxSection, generalised to any option so
  // Color+Size products match the full combination, not just size).
  getSelectedOptionValues() {
      const checkedInputs = Array.from(
          this.mainSection.querySelectorAll('variant-selects input[type="radio"][data-option-name]:checked')
      );
      if (!checkedInputs.length) return null;

      const ordered = [];
      checkedInputs.forEach((input, i) => {
          const positionMatch = (input.name || "").trim().match(/-(\d+)$/);
          const position = positionMatch ? parseInt(positionMatch[1], 10) - 1 : i;
          ordered[position] = input.value;
      });
      return ordered;
  }

  updateSwitcherAvailability() {
      const selectedOptions = this.getSelectedOptionValues();
      if (!selectedOptions || !selectedOptions.length) return;

      const variantsByProductId = {};
      this.mainSection.querySelectorAll('script[js-product-json]').forEach((script) => {
          try {
              const data = JSON.parse(script.textContent);
              if (data && data.product_id) variantsByProductId[data.product_id] = data.variants || [];
          } catch (e) {}
      });

      this.mainSection.querySelectorAll(this.selectors.stitcherItem).forEach((item) => {
          const productId = item.getAttribute("data-product-id");
          const variants = variantsByProductId[productId];

          const match = variants && variants.find((variant) =>
              Array.isArray(variant.options) &&
              variant.options.length === selectedOptions.length &&
              variant.options.every((value, index) => value === selectedOptions[index])
          );

          const unavailable = !match || match.available !== true;
          item.classList.toggle("is-disabled", unavailable);
      });
  }

  // ---- Force "no variant selected" state --------------------------------
  // - Unchecks every option input (Size, and any other option) so nothing
  //   ever reads as pre-selected, whether that's Liquid's own default
  //   ("first available variant checked") on first load, or a stale
  //   selection carried over in freshly-fetched AJAX markup.
  // - Clears the variant id hidden input(s) so nothing purchasable could
  //   ever be submitted while no option is actually chosen.
  // - Disables Add to cart and swaps its label to "Please select size"
  //   until the shopper picks something.
  //
  // Once the shopper actually clicks an option, the existing variant-select
  // → product-info flow (handleOptionValueChange → renderProductInfo →
  // handleUpdateProductInfo → productForm.toggleSubmitButton(...)) takes
  // back over and drives the button to its real available/sold-out state,
  // so this method never needs to run again until the next reset point
  // (page load or product switch).
  resetVariantSelectionState(container) {
      if (!container) return;

      // Products with no variants (single "Default Title" variant) have no
      // option inputs to pick from. Leave the form untouched so the variant
      // id stays in place and Add to cart stays enabled.
      const hasVariantOptions = container.querySelector(
          'variant-selects input[type="radio"][data-option-name], variant-selects select[data-option-name]'
      );
      if (!hasVariantOptions) return;

      // 1. Uncheck every option input so nothing reads as pre-selected.
      container.querySelectorAll('variant-selects input[type="radio"][data-option-name]').forEach((input) => {
          input.checked = false;
      });
      container.querySelectorAll('variant-selects select[data-option-name]').forEach((select) => {
          const placeholder = select.querySelector('option[value=""]');
          if (placeholder) select.value = "";
      });

      // 2. Clear the variant id(s) so no variant could be submitted as-is.
      container.querySelectorAll('input[name="id"]').forEach((input) => {
          input.value = "";
      });

      // 3. Disable Add to cart and prompt for a size.
      const productForm = container.querySelector("product-form");
      if (productForm && typeof productForm.toggleSubmitButton === "function") {
          productForm.toggleSubmitButton(true, "Please select size");
          return;
      }

      // Fallback for when product-form hasn't upgraded yet (or is missing):
      // update the button in the DOM directly so the disabled state/text
      // still lands correctly.
      container.querySelectorAll('button[name="add"]').forEach((button) => {
          button.setAttribute("disabled", "disabled");
          // button.classList.add("disabled");
          const label = button.querySelector("span");
          if (label) {
              label.textContent = "Please select size";
          } else {
              button.textContent = "Please select size";
          }
      });
  }

  init() {
      // this.stitcherItems.forEach(stitcherItem =>
      //     stitcherItem.addEventListener("click", this.renderSectionFromFetch.bind(this))
      // );
      // Warm the template-sync cache so a template change feels instant.
      this.stitcherItems.forEach((item) => {
          const warm = () => {
              if (item.dataset.templateSuffix !== this.mainSection?.dataset.templateSuffix) {
                  window.PdpTemplateSectionSync?.prefetch(item.getAttribute("data-product-handle"));
              }
          };
          item.addEventListener("pointerenter", warm, { once: true });
          item.addEventListener("touchstart", warm, { once: true, passive: true });
      });

        this.stitcherItems.forEach(stitcherItem =>
        stitcherItem.addEventListener("click", (e) => {

          this.fabricDropdowns.forEach(drop => {
            const val = drop.getAttribute("value") || null;
            const text = drop.getAttribute("text") || null;


            if (val) {
              drop.value = val;
              drop.setAttribute("value", val);
            }
            if (text) {
              drop.setAttribute("text", text);
            }
          });

          this.mobilefabricDropdowns.forEach(drop => {
            const val = drop.getAttribute("value") || null;
            const text = drop.getAttribute("text") || null;

            
            if (val) {
              drop.value = val;
              drop.setAttribute("value", val);
            }
            if (text) {
              drop.setAttribute("text", text);
            }
          });

          this.renderSectionFromFetch(e);
        })
      );

      // Desktop Fabric Dropdown change
      this.fabricDropdowns.forEach(drop =>
          drop.addEventListener("change", (e) => {
            const wrapper = e.currentTarget.closest(".prodocut-tab-wrapper-inner");

            // 1️⃣ Get active category text dynamically
            let activeCategory = wrapper
          ?.querySelector("[js-sub-category] .tab-item.active .tab-item-text")
          ?.textContent.trim().toLowerCase();

        if (activeCategory) {
          activeCategory = activeCategory.replace(/\s+/g, "-"); // spaces → hyphens
        }

            if (!activeCategory) return;

            // normalize spaces, underscores, etc.
            // activeCategory = activeCategory.replace(/\s+/g, "-");

            // 2️⃣ Get selected dropdown item
            const selectedItem = wrapper?.querySelector("[js-fabric-dropdown-item].selected");
            if (!selectedItem) return;

            // 3️⃣ Find dataset key dynamically (must include activeCategory + "product")
            let matchingKey = Object.keys(selectedItem.dataset).find(key => {
              const kebabKey = key.replace(/([a-z0-9])([A-Z])/g, "$1-$2").toLowerCase();
              return kebabKey.includes(activeCategory);
            });
            if (!matchingKey && drop.hasAttribute('js-display-default-product')) {
            matchingKey = Object.keys(selectedItem.dataset)[0];
          }
            if (!matchingKey) {
              console.warn(`No dataset key found for category: ${activeCategory}`);
              console.log("Available dataset keys:", Object.keys(selectedItem.dataset));
              return;
            }

            // 4️⃣ Get product handle & render
            const productHandle = selectedItem.dataset[matchingKey];
            if (productHandle) {
              this._renderByHandle(productHandle);
            }
          })
      );

      this.mobilefabricDropdowns.forEach(drop =>
        drop.addEventListener("change", (e) => {
          const wrapper = e.currentTarget.closest(".prodocut-tab-wrapper-inner.product-tab.medium-up--hide");

          // 1️⃣ Get active category text dynamically
            let activeCategory = wrapper
            ?.querySelector("[js-sub-category] .tab-item.active .tab-item-text")
            ?.textContent.trim().toLowerCase();

            if (activeCategory) {
              activeCategory = activeCategory.replace(/\s+/g, "-"); // spaces → hyphens
            }

            if (!activeCategory) return;

            // normalize spaces, underscores, etc.
            // activeCategory = activeCategory.replace(/\s+/g, "-");

            // 2️⃣ Get selected dropdown item
            const selectedItem = wrapper?.querySelector("[js-mobile-fabric-dropdown-item].selected");
            if (!selectedItem) return;

            // 3️⃣ Find dataset key dynamically (must include activeCategory + "product")
            let matchingKey = Object.keys(selectedItem.dataset).find(key => {
              const kebabKey = key.replace(/([a-z0-9])([A-Z])/g, "$1-$2").toLowerCase();
              return kebabKey.includes(activeCategory);
            });
            if (!matchingKey && drop.hasAttribute('js-display-default-product')) {
            matchingKey = Object.keys(selectedItem.dataset)[0];
          }
            if (!matchingKey) {
              console.warn(`No dataset key found for category: ${activeCategory}`);
              console.log("Available dataset keys:", Object.keys(selectedItem.dataset));
              return;
            }

            // 4️⃣ Get product handle & render
            const productHandle = selectedItem.dataset[matchingKey];
            if (productHandle) {
              this._renderByHandle(productHandle);
            }
        })
      );
      this.productsTab()
  }

  _renderByHandle(handle) {
      this.updateLoading();
      this.syncTemplateSections(handle).finally(() => this._renderByHandleNow(handle));
  }

  _renderByHandleNow(handle) {
      Object.entries(this.sections).forEach(
          ([key, { element, selector, initEvents = [] }]) => {

              if (!element || !element.isConnected) return;

              this.renderSection(
                  handle,
                  element,
                  selector,
                  ...initEvents
              );
          }
      );
  }
  renderSectionFromFetch(evt) {
      evt.preventDefault();

      const { currentTarget } = evt;
      const handle = currentTarget.getAttribute("data-product-handle");

      this.updateLoading();

      this.syncTemplateSections(handle, currentTarget.dataset.templateSuffix)
          .finally(() => this._renderSectionsNow(handle, currentTarget));
  }

  _renderSectionsNow(handle, currentTarget) {
      Object.entries(this.sections).forEach(
          ([key, { element, selector, initEvents = [] }]) => {

              if (key === "mediaCarousel") {
                  document.querySelectorAll(selector).forEach((target) => {
                      // skip a wrapper nested inside another wrapper
                      if (target.parentElement?.closest(selector)) return;

                      this.renderSection(handle, target, selector, currentTarget);
                  });
                  return;
              }

              if (!element || !element.isConnected) return;

              this.renderSection(handle, element, selector, currentTarget, ...initEvents);
          }
      );
  }

  updateURLHash(handle) {
      const url = `/products/${handle}`;
      window.history.replaceState({}, '', url);
  }

  // Adds/removes template-specific sections when the target product uses a
  // different PDP template. Never rejects: on failure the normal swap continues.
  syncTemplateSections(handle, targetSuffix) {
      if (!window.PdpTemplateSectionSync) return Promise.resolve();
      if (targetSuffix === undefined) {
          const item = this.querySelector(`${this.selectors.stitcherItem}[data-product-handle="${handle}"]`);
          targetSuffix = item?.dataset.templateSuffix;
      }
      return window.PdpTemplateSectionSync
          .sync({ handle, targetSuffix: targetSuffix ?? null, mainSection: this.mainSection })
          .catch((e) => console.warn(e));
  }

  syncRootAttributes(container, fresh) {
      Array.from(container.attributes).forEach((attr) => {
          if (!fresh.hasAttribute(attr.name)) container.removeAttribute(attr.name);
      });
      Array.from(fresh.attributes).forEach((attr) => container.setAttribute(attr.name, attr.value));
  }

  updateLoading() {
      this.sections.mainProduct.element.classList.add("section--loading");
  }

  renderSection(handle, container, selector, currentTarget, ...initEvents) {
      let sectionId = container.getAttribute("data-section");
      const url = `/products/${handle}?section_id=${sectionId}`;
      this.ajaxSection(url, container, selector, handle, currentTarget, initEvents);
  }

  ajaxSection(url, container, selector, handle, currentTarget,  initEvents = []) { 
    const currentDropdown = document.querySelector("fabric-dropdown");
    const currentFabricValue = currentDropdown?.value;
    const currentFabricLabel = currentDropdown?.getAttribute("text");

    // mobile dropdown
    const mobilecurrentDropdown = document.querySelector("mobile-fabric-dropdown");
    const mobilecurrentFabricValue = mobilecurrentDropdown?.value;
    const mobilecurrentFabricLabel = mobilecurrentDropdown?.getAttribute("text");

      // Remember the currently selected size so we can re-select it on the new product
      const previouslySelectedSizeInput = container.querySelector(
        'variant-selects input[type="radio"][data-option-name="Size"]:checked'
      );
      const previouslySelectedSizeValue = previouslySelectedSizeInput ? previouslySelectedSizeInput.value : null;

      if (selector === this.selectors.productReviews) {
        container.dataset.reviewsHandle = handle;
      }


      fetch(url)
    .then((response) => response.text())
    .then((html) => {

        const parsedDocument = new DOMParser().parseFromString(html, 'text/html');
        const ajaxContainer = new DOMParser().parseFromString(html, 'text/html').querySelector(selector);

        // Trust Stats is outside the product switcher and must be
        // explicitly updated when the product changes.
        if (selector === this.selectors.trustStats) {
            const currentTrustStats = container;
            
            if (ajaxContainer) {
                currentTrustStats.innerHTML = ajaxContainer.innerHTML;
            } else {
                currentTrustStats.innerHTML = '';
            }

            // Re-initialize Trust Stats JS after AJAX replacement
            requestAnimationFrame(() => {
                if (typeof window.initTrustStats === 'function') {
                    window.initTrustStats();
                }
            });

            return;
        }

        if (selector === this.selectors.mediaCarousel) {
            window.PdpMediaCardCarousel?.destroyWithin?.(container);

            container.innerHTML = ajaxContainer ? ajaxContainer.innerHTML : '';

            requestAnimationFrame(() => {
                window.PdpMediaCardCarousel?.initWithin?.(container);
            });
            return;
        }

        // Reviews live outside the product switcher, so they are handled on
        // their own and MUST return here. Previously they fell through to the
        // `input[name="product-id"]` check below (which the reviews section
        // never contains) and bailed out before the reload code could run.
        if (selector === this.selectors.productReviews) {
            this.renderReviews(container, ajaxContainer, handle);
            return;
        }

        // FAQ / collapsible content: when the target product has no such section,
        // clear the stale one instead of leaving the previous product's content.
        if (!ajaxContainer && (selector === this.selectors.faqSection || selector === this.selectors.collapsibleContent)) {
            container.innerHTML = '';
            container.hidden = true;
            return;
        }

        if (ajaxContainer && selector !== this.selectors.productReviews) {

    if (selector === this.selectors.mainSection) {

        Array.from(container.attributes).forEach((attr) => {
            if (!ajaxContainer.hasAttribute(attr.name)) {
                container.removeAttribute(attr.name);
            }
        });

        Array.from(ajaxContainer.attributes).forEach((attr) => {
            container.setAttribute(attr.name, attr.value);
        });

        const liveProductInfo = container.closest('product-info, [js-dd-product-info]');
        const freshProductInfo = ajaxContainer.closest('product-info, [js-dd-product-info]');
        if (liveProductInfo && freshProductInfo) {
            Array.from(liveProductInfo.attributes).forEach((attr) => {
                if (!freshProductInfo.hasAttribute(attr.name)) {
                    liveProductInfo.removeAttribute(attr.name);
                }
            });
            Array.from(freshProductInfo.attributes).forEach((attr) => {
                liveProductInfo.setAttribute(attr.name, attr.value);
            });
        }
        
        window.PdpStockAlertSync?.capture();
        container.innerHTML = ajaxContainer.innerHTML;
        window.PdpStockAlertSync?.restore(container, handle);

        // The product media modal (zoom) is rendered outside [js-dd-main-product]
        // (same id across products since section.id doesn't change), so it never
        // gets touched by the innerHTML swap above. Refresh it explicitly here.
        const sectionId = container.getAttribute("data-section");
          if (sectionId) {
              const modalId = `ProductModal-${sectionId}`;
              const oldModal = document.getElementById(modalId);
              const newModal = parsedDocument.getElementById(modalId);

              if (oldModal && newModal && oldModal !== newModal) {
                  oldModal.innerHTML = newModal.innerHTML;

                  // Re-bind close button: its old listener was destroyed with the old node
                  const closeBtn = oldModal.querySelector('[id^="ModalClose-"]');
                  if (closeBtn && typeof oldModal.hide === 'function') {
                      closeBtn.addEventListener('click', oldModal.hide.bind(oldModal));
                  }
              }
          }
        
        const newProductInfo = liveProductInfo;

    } else {
        // These two carry per-product state on their ROOT element (class, style,
        // hidden, ...), not just inside it, so copy the root attributes as well.
        if (selector === this.selectors.faqSection || selector === this.selectors.collapsibleContent) {
            this.syncRootAttributes(container, ajaxContainer);
        }
        container.innerHTML = ajaxContainer.innerHTML;

    }
}

        // KEEP YOUR EXISTING CODE BELOW THIS POINT
        if (window.initBundleSet) {
            window.initBundleSet(container);
        }

              // if (selector === this.selectors.mainSection) {
              //     const productInfo = container.querySelector('product-info');
              //     if (productInfo) {
              //         productInfo.dataset.productStitcher = 'true';
              //     }
              // }

              if (window.initBundleSet) {
                  window.initBundleSet(container);
              }

              if (!ajaxContainer) return;
              if (!ajaxContainer.querySelector('input[name="product-id"]')) return;

              const productId = ajaxContainer.querySelector('input[name="product-id"]')?.getAttribute("value");

              // requestAnimationFrame(() => {
              //     const recommendation = document.querySelector("product-recommendations");

              //     if (!recommendation || !productId) return;

              //     recommendation.dataset.productId = productId;
              //     recommendation.innerHTML = "";
              //     recommendation.initializeRecommendations(productId);
              // });

              requestAnimationFrame(() => {
                const recommendation =
                  document.querySelector("product-recommendations");

                if (!recommendation || !productId) return;

                if (window.destroyRelatedSwiper) {
                  window.destroyRelatedSwiper(recommendation);
                }

                recommendation.innerHTML = "";
                recommendation.dataset.productId = productId;

                // Start observing before Dawn inserts the new recommendations
                if (window.watchRelatedProductsSwiper) {
                  window.watchRelatedProductsSwiper(recommendation);
                }

                if (
                  typeof recommendation.initializeRecommendations ===
                  "function"
                ) {
                  recommendation.initializeRecommendations(productId);
                }
              });



              initPDPFAQs();

              if(selector === this.selectors.mainSection) { 
                // theme.sections.register('product', theme.Product);
                // const updatedVariantSizes = container.querySelectorAll("variant-selects [js-size-input]")
             
                // if(previouslySelectedSize){
                  
                //   updatedVariantSizes.forEach((variantSize) => {
                //     if(variantSize.value == previouslySelectedSize.value){
                //       // variantSize.nextElementSibling.click()
                //       setTimeout(function(){
                //         variantSize.nextElementSibling.click()
                //       },500)
                //     }
                //   })
                // }

                if (document.querySelector('[js-dd-product-switcher].selected')?.getAttribute("data-view-selection") === "crew") {
                  document.body.classList.add("crew_selected");
                } else {
                  document.body.classList.remove("crew_selected");
                }

                if (document.querySelector('[js-dd-product-switcher].selected')?.getAttribute("data-view-selection") === "365") {
                  document.body.classList.add("hb_collection__365-selected");
                } else {
                  document.body.classList.remove("hb_collection__365-selected");
                }

                document.dispatchEvent(new CustomEvent('pdp-productlist:init'))
                document.dispatchEvent(new CustomEvent('changeReviewsWidgetColors:init'))

                 requestAnimationFrame(() => {
                  this.playVisibleProductVideos(container);
                });

                // [nector] to updat the points earning widget
                const customerEarnElement = container.querySelector('script[data-op="customerearn"]');
                if (customerEarnElement) {
                    const customerEarnParent = customerEarnElement.parentElement;
                    const clonedCustomerEarnElement = document.createElement('script');

                    // Copy all attributes from the original element to the cloned element
                    Array.from(customerEarnElement.attributes).forEach(attr => {
                      clonedCustomerEarnElement.setAttribute(attr.name, attr.value);
                    });

                    customerEarnParent.removeChild(customerEarnElement);

                    // Append the cloned element to the parent
                    customerEarnParent.appendChild(clonedCustomerEarnElement);

                              setTimeout(() => {
                      // Remove the existing script tag with the specified URL
                      document.querySelectorAll('script[src^="https://cdn.nector.io/nector-static/no-cache/reward-widget/package/customerearn.min.js"]').forEach(element => element.remove());

                      // Create a new script element with the updated URL and attributes
                      const customerEarnScript = document.createElement("script");
                      customerEarnScript.src = "https://cdn.nector.io/nector-static/no-cache/reward-widget/package/customerearn.min.js" + `?t=${Date.now()}`;
                      customerEarnScript.setAttribute("type", "module");

                      // Append the new script element to the body
                      document.body.appendChild(customerEarnScript);
                    }, 1000)
                  }

                  const newDropdown = container.querySelector("fabric-dropdown") || document.querySelector("fabric-dropdown");

                  if (newDropdown && currentFabricValue) {
                    newDropdown.setAttribute("value", currentFabricValue);
                    if (currentFabricLabel) {
                      newDropdown.setAttribute("text", currentFabricLabel);
                      const selectedTextEl = newDropdown.querySelector("[js-fabric-dropdown-selected-text]");
                      if (selectedTextEl) selectedTextEl.textContent = currentFabricLabel;
                    }
                  }

                  // mobile code 
                  const mobile_newDropdown = container.querySelector("mobile-fabric-dropdown") || document.querySelector("mobile-fabric-dropdown");


                  if (mobile_newDropdown && mobilecurrentFabricValue) {
                    mobile_newDropdown.setAttribute("value", mobilecurrentFabricValue);
                    if (mobilecurrentFabricLabel) {
                      mobile_newDropdown.setAttribute("text", mobilecurrentFabricLabel);
                      const mobileselectedTextEl = mobile_newDropdown.querySelector("[js-mobile-fabric-dropdown-selected-text]");
                      if (mobileselectedTextEl) mobileselectedTextEl.textContent = mobilecurrentFabricLabel;
                    }
                  }
                  // Re-apply the previously selected size (e.g. "L") to the newly rendered
                  // product. The fresh <product-stitcher> constructed a moment ago (as part
                  // of the innerHTML swap above) already reset this product to "nothing
                  // selected / Add to cart disabled" via resetVariantSelectionState(), so:
                  // - if the shopper had chosen a size, we try to restore that exact size here;
                  // - if that size doesn't exist or is sold out on this product (or the
                  //   shopper never chose a size to begin with), the reset above is simply
                  //   left in place — no size selected, Add to cart disabled, "Please select
                  //   size" shown — instead of silently falling back to some default variant.
                  if (previouslySelectedSizeValue) {
                    const updatedVariantSizes = container.querySelectorAll(
                      'variant-selects input[type="radio"][data-option-name="Size"]'
                    );
                    const matchingSizeInput = Array.from(updatedVariantSizes).find(
                      (variantSize) => variantSize.value === previouslySelectedSizeValue
                    );

                    // Only switch selection if that size actually exists AND is purchasable
                    // (not sold out) on the newly loaded product.
                    if (
                      matchingSizeInput &&
                      !matchingSizeInput.checked &&
                      !matchingSizeInput.classList.contains("disabled") &&
                      !matchingSizeInput.disabled
                    ) {
                      requestAnimationFrame(() => {
                        const sizeLabel = matchingSizeInput.nextElementSibling;
                        if (sizeLabel && sizeLabel.tagName === "LABEL" && typeof sizeLabel.click === "function") {
                          sizeLabel.click();
                        } else {
                          matchingSizeInput.checked = true;
                          matchingSizeInput.dispatchEvent(new Event("change", { bubbles: true }));
                        }
                      });
                    }
                  }

                  function filterFabricOptions(wrapper) {
                      // 1️⃣ Get active category
                      let activeCategory = wrapper
                      ?.querySelector("[js-sub-category] .tab-item.active .tab-item-text")
                      ?.textContent.trim().toLowerCase();

                    if (activeCategory) {
                      activeCategory = activeCategory.replace(/\s+/g, "-"); // spaces → hyphens
                    }

                      if (!activeCategory) return;

                      // 2️⃣ Loop through fabric options
                      const fabricOptions = wrapper.querySelectorAll("[js-fabric-dropdown-item]");
                      fabricOptions.forEach(item => {
                        // 3️⃣ Find matching dataset key dynamically
                        const matchingKey = Object.keys(item.dataset).find(key => {
                          const kebabKey = key.replace(/([a-z0-9])([A-Z])/g, "$1-$2").toLowerCase();
                          return kebabKey.includes(activeCategory);
                        });
                          

                        // 4️⃣ Show if product exists, hide if not
                        if (matchingKey && item.dataset[matchingKey]) {
                          item.style.display = "";   // ✅ show
                        } else {
                          item.style.display = "none"; // 🚫 hide
                        }
                      });
                    }
                  filterFabricOptions(this.mainSection);
              }

              // if(selector === this.selectors.productReviews) {
              //   const newProductId = ajaxContainer.querySelector('script').getAttribute('data-product_id');
              //   const script_hb = document.createElement('script');
              //   script_hb.src = "https://cdn.nector.io/nector-static/no-cache/reward-widget/mainloader.min.js";
              //   script_hb.setAttribute("data-api_key", "c25d2022cdfbc0d71d658767d386feb8ecaa6227f7678b867b3e9a5fdde81ab6");
              //   script_hb.setAttribute("data-platform", "shopify");
              //   script_hb.setAttribute("async", "");
              //   script_hb.setAttribute("data-platform_url", "https://platform.nector.io");
              //   script_hb.setAttribute("data-op", "review_list");
              //   script_hb.setAttribute("data-view_type", "row");
              //   script_hb.setAttribute("data-hide_total_review_count", "true");
              //   script_hb.setAttribute("data-product_id", newProductId);
              //   script_hb.setAttribute("data-websdk_url", "https://websdk.nector.io");
              //   script_hb.setAttribute("data-entity_id", "6180bc3e-14d2-4c9e-9bb2-b2cfd08159a6");
              //   script_hb.setAttribute("data-default_reviews_sort", "created_at");  

              //   document.querySelectorAll('script[src*="https://cdn.nector.io"]').forEach(script => {
              //       script.remove();
              //   })

              //   container.innerHTML = '';
              //   container.append(script_hb);

              //   script_hb.onload = function() {
              //     document.querySelectorAll('script[src="https://cdn.nector.io/nector-static/no-cache/reward-widget/package/reviews.min.js"]').forEach(element => element.remove());
              
              //     const reviewScript = document.createElement("script");
              //     reviewScript.src = "https://cdn.nector.io/nector-static/no-cache/reward-widget/package/reviews.min.js" + `?timestamp=${Date.now()}`;
              //     reviewScript.setAttribute("type", "module");
              //     document.body.appendChild(reviewScript);
              //   }
              // }
              initEvents.forEach(eventName => document.dispatchEvent(new CustomEvent(eventName)));
              this.updateURLHash(handle);
          })
          .catch(err => {
              console.log(err)
          })
  }

    // ---- Reviews (Nector) ------------------------------------------------
  // Swaps in the reviews section rendered for the newly selected product and
  // re-boots the Nector review widget for it. The <script> in the fetched
  // markup is inert (DOMParser), so we rebuild a live copy that keeps every
  // data-* attribute Liquid rendered (product id, api key, entity id, env...).
  renderReviews(container, ajaxContainer, handle) {
      if (!ajaxContainer) return;

      // A newer switch has started since this response was requested: ignore.
      if (container.dataset.reviewsHandle && container.dataset.reviewsHandle !== handle) return;

      const freshScript =
          ajaxContainer.querySelector('script[data-op="review_list"]') ||
          ajaxContainer.querySelector('script[data-product_id]');
      if (!freshScript) return;

      // Drop old Nector loader scripts so the widget re-initialises.
      document.querySelectorAll('script[src*="https://cdn.nector.io"]').forEach((el) => el.remove());

      // Swap markup (keeps title + view-selection classes) with a slot where
      // the script goes.
      const slot = document.createElement('span');
      slot.setAttribute('data-nector-slot', '');
      freshScript.replaceWith(slot);

      container.className = ajaxContainer.className;
      container.innerHTML = ajaxContainer.innerHTML;

      const liveScript = document.createElement('script');
      Array.from(freshScript.attributes).forEach((attr) => {
          liveScript.setAttribute(attr.name, attr.value);
      });

      liveScript.onload = () => {
          document
              .querySelectorAll('script[src^="https://cdn.nector.io/nector-static/no-cache/reward-widget/package/reviews.min.js"]')
              .forEach((el) => el.remove());

          const reviewScript = document.createElement('script');
          reviewScript.src =
              "https://cdn.nector.io/nector-static/no-cache/reward-widget/package/reviews.min.js" +
              `?timestamp=${Date.now()}`;
          reviewScript.setAttribute('type', 'module');
          document.body.appendChild(reviewScript);
      };

      const liveSlot = container.querySelector('[data-nector-slot]');
      if (liveSlot) {
          liveSlot.replaceWith(liveScript);
      } else {
          container.appendChild(liveScript);
      }
  }

  
productsTab() {
  
  const tabHeaders = this.mainSection.querySelectorAll('[js-dd-product-tab-header]');

  // 🔹 Helper: Hide fabric options if product not available for active tab
  function filterFabricOptions(wrapper) {
    // 1️⃣ Get active category
    let activeCategory = wrapper
    ?.querySelector("[js-sub-category] .tab-item.active .tab-item-text")
    ?.textContent.trim().toLowerCase();

  if (activeCategory) {
    activeCategory = activeCategory.replace(/\s+/g, "-"); // spaces → hyphens
  }

    if (!activeCategory) return;

    // 2️⃣ Loop through fabric options
    const fabricOptions = wrapper.querySelectorAll("[js-fabric-dropdown-item]");
    fabricOptions.forEach(item => {
      // 3️⃣ Find matching dataset key dynamically
      const matchingKey = Object.keys(item.dataset).find(key => {
        const kebabKey = key.replace(/([a-z0-9])([A-Z])/g, "$1-$2").toLowerCase();
        return kebabKey.includes(activeCategory);
      });
      // const matchingKey = Object.keys(item.dataset)
      //   .find(key => {
      //   key.replace(/([a-z0-9])([A-Z])/g, "$1-$2").toLowerCase();
      //   return matchingKey.includes(activeCategory);
      //   })

      // 4️⃣ Show if product exists, hide if not
      if (matchingKey && item.dataset[matchingKey]) {
        item.style.display = "";   
      } else {
        item.style.display = "none"; 
      }
    });
  }

  tabHeaders.forEach(tabHeader => {
    tabHeader.addEventListener('click', () => {
      // Remove "active" class from all headers and panels
      tabHeaders.forEach(header => header.classList.remove('active'));
      const tabPanels = this.mainSection.querySelectorAll('[js-dd-product-tab-body]');
      tabPanels.forEach(panel => panel.classList.remove('active'));

      // Activate the clicked tab
      tabHeader.classList.add('active');
      const index = tabHeader.getAttribute('data-product-tab-header-index');
      const activePanel = this.mainSection.querySelector(`[data-product-tab-body-index="${index}"]`);
      if (activePanel) activePanel.classList.add('active');

      // Handle product selection
      const categoryProducts = activePanel.querySelectorAll('[js-dd-product-switcher]');
      if (Array.from(categoryProducts).some(product => product.classList.contains('selected'))) {
        const selectedProduct = activePanel.querySelector('.selected[js-dd-product-switcher]');
        if (selectedProduct) selectedProduct.click();
      } else if (categoryProducts.length > 0) {
        categoryProducts[0].classList.add('selected');
        categoryProducts[0].click();
      }

      // 🔹 After tab change → filter fabric options
      filterFabricOptions(this.mainSection);
    });
  });
}


}

customElements.define('product-stitcher', ProductStitcher);


class FabricDropdown extends HTMLElement {
  static get observedAttributes() { return ["value"]; }
  constructor() {
    super();

    this.selectors = {
      header:           "[js-fabric-dropdown-header]",
      arrow:            "[js-fabric-dropdown-arrow]",
      list:             "[js-fabric-dropdown-list]",
      item:             "[js-fabric-dropdown-item]",
      selectedText:     "[js-fabric-dropdown-selected-text]",
      container:        "[js-fabric-dropdown-container]" 
    };

    
    this.header       = this.querySelector(this.selectors.header);
    this.arrow        = this.querySelector(this.selectors.arrow);
    this.list         = this.querySelector(this.selectors.list);
    this.items        = this.querySelectorAll(this.selectors.item);
    this.selectedText = this.querySelector(this.selectors.selectedText);

    
    this.isOpen = false;
    this.value  = null;         

    this.init();
  }

  connectedCallback() {
  const initial = this.getAttribute("value");

  // Case 1: If "value" attribute is passed, select it
  if (initial) {
    requestAnimationFrame(() => (this.selectedValue = initial));
  } else {
    // Case 2: Auto-select first matching item for the active category
    requestAnimationFrame(() => {
      const wrapper = this.closest(".prodocut-tab-wrapper-inner");
      let activeCategory = wrapper
        ?.querySelector("[js-sub-category] .tab-item.active .tab-item-text")
        ?.textContent.trim().toLowerCase();

      if (activeCategory) {
        activeCategory = activeCategory.replace(/\s+/g, "-");
      }
      const showAll = this.hasAttribute('js-display-default-product');
      // Try to find an item whose dataset matches the active category
      this.items.forEach(item => {
        if(showAll){
          item.style.display = "";
        }
        else{
          const hasMatch = Object.keys(item.dataset).some(key => {
          const kebabKey = key.replace(/([a-z0-9])([A-Z])/g, "$1-$2").toLowerCase();
          return activeCategory && kebabKey.includes(activeCategory) && item.dataset[key];
        });

        item.style.display = hasMatch ? "" : "none";
        }
        
      });

      const visibleItem = Array.from(this.items).some(el => el.style.display !== "none");
      if (!visibleItem) {
        this._showPlaceholder();
      }
    });
  }
}

  
  attributeChangedCallback(name, oldVal, newVal) {
      
      if (name === "value") {
        if (newVal) {
          requestAnimationFrame(() => {
            this.selectedValue = newVal;
          });
        } else {
          this.value = null;
          this._clearSelectionStyles();
          this._showPlaceholder();
        }
      }
  }

  get selectedValue() { return this.value; }
  set selectedValue(val) {
    const match = Array.from(this.items)
      .find(i => i.dataset.fabricProduct === val);
    if (match) this._selectItem({ currentTarget: match, silent: true });
  }

  
  init() {    
    this.header.addEventListener("click",  this._toggleDropdown.bind(this));

    this.items.forEach(item =>
      item.addEventListener("click", this._selectItem.bind(this))
    );

    document.addEventListener("click", this._handleOutside.bind(this));

    // if (this.items.length && !this.value) {
    //   this._selectItem({ currentTarget: this.items[0], silent: true });
    // }
  }

  disconnectedCallback() {
    document.removeEventListener("click", this._handleOutside.bind(this));
  }

  _toggleDropdown() {
    this.isOpen = !this.isOpen;
    this.list.classList.toggle("open",   this.isOpen);
    this.list.classList.toggle("closed", !this.isOpen);
    this.setAttribute("aria-expanded", this.isOpen);
    if (this.isOpen) {
      document.body.classList.add("active_dropdown");
    } else {
      document.body.classList.remove("active_dropdown");
    }
  }


_selectItem(evt) {
  const el = evt.currentTarget || evt.target;
  const label = el.textContent.trim();

  // 1️⃣ Get active category (ex: "Regular Fit", "Relaxed Fit", "Oversized")
  const wrapper = this.closest(".prodocut-tab-wrapper-inner");
  let activeCategory = wrapper
    ?.querySelector("[js-sub-category] .tab-item.active .tab-item-text")
    ?.textContent.trim().toLowerCase();

  if (activeCategory) {
    activeCategory = activeCategory.replace(/\s+/g, "-"); // spaces → hyphens
  }
const showAll = this.hasAttribute('js-display-default-product');

  // 2️⃣ Normalize dataset keys (camelCase → kebab-case)
  let code = null;
  if (activeCategory) {
    const matchAttr = Object.keys(el.dataset).find(key => {
      // convert camelCase → kebab-case
      const kebabKey = key
        .replace(/([a-z0-9])([A-Z])/g, "$1-$2")
        .toLowerCase();
        if (showAll) return el.dataset[key]; 
      return kebabKey.includes(activeCategory);
    });

    if (matchAttr) {
      code = el.dataset[matchAttr];
    }
  }

  // 3️⃣ Fallback
  if (!code) {
    console.warn("No product handle found for", activeCategory, el.dataset);
    return;
  }

  // 4️⃣ If same as current, just toggle
  if (code === this.value) {
    this._toggleDropdown();
    return;
  }

  // 5️⃣ Update selection
  this._clearSelectionStyles();
  el.classList.add("selected");
  this.selectedText.textContent = label;

  this.value = code;
  this.setAttribute("value", code);
  this.setAttribute("text", label);

  if (!evt.silent) {
    this.dispatchEvent(new CustomEvent("change", {
      bubbles: true,
      detail: { value: code }
    }));
  }

  this._toggleDropdown();
}

  _clearSelectionStyles() {
    this.items.forEach(i => i.classList.remove("selected"));
  }

  _showPlaceholder() {
    this.selectedText.textContent =
      this.getAttribute("placeholder") || "Select Fabric";
  }

  _handleOutside(evt) {
    if (!this.contains(evt.target) && this.isOpen) this._toggleDropdown();
  }
}

customElements.define("fabric-dropdown", FabricDropdown);



class mobileFabricDropdown extends HTMLElement {
  static get observedAttributes() { return ["value"]; }
  constructor() {
    super();

    this.selectors = {
      header:           "[js-mobile-fabric-dropdown-header]",
      arrow:            "[js-mobile-fabric-dropdown-arrow]",
      list:             "[js-mobile-fabric-dropdown-list]",
      overlay:          "[js-mobile-fabric-dropdown-overlay]",
      item:             "[js-mobile-fabric-dropdown-item]",
      selectedText:     "[js-mobile-fabric-dropdown-selected-text]",
      container:        "[js-mobile-fabric-dropdown-container]"   
    };

    
    this.header       = this.querySelector(this.selectors.header);
    this.arrow        = this.querySelector(this.selectors.arrow);
    this.list         = this.querySelector(this.selectors.list);
    this.overlay      = this.querySelector(this.selectors.overlay);
    this.items        = this.querySelectorAll(this.selectors.item);
    this.selectedText = this.querySelector(this.selectors.selectedText);

    
    this.isOpen = false;
    this.value  = null;         

    this.init();
  }
connectedCallback() {
    const initial = this.getAttribute("value");
      if (initial) {
        // wait a frame so items are parsed
        requestAnimationFrame(() => (this.selectedValue = initial));
      } else {
        
        requestAnimationFrame(() => {
        const wrapper = this.closest(".prodocut-tab-wrapper-inner.product-tab.medium-up--hide");
        let activeCategory = wrapper
          ?.querySelector("[js-sub-category] .tab-item.active .tab-item-text")
          ?.textContent.trim().toLowerCase();

        if (activeCategory) {
          activeCategory = activeCategory.replace(/\s+/g, "-");
        }
        const showAll = this.hasAttribute('js-display-default-product');
        // Try to find an item whose dataset matches the active category
        this.items.forEach(item => {
          if (showAll) {
            item.style.display = "";
          }
          else {
            const hasMatch = Object.keys(item.dataset).some(key => {
              const kebabKey = key.replace(/([a-z0-9])([A-Z])/g, "$1-$2").toLowerCase();
              return activeCategory && kebabKey.includes(activeCategory) && item.dataset[key];
            });

            item.style.display = hasMatch ? "" : "none";
          }

        });

        const visibleItem = Array.from(this.items).some(el => el.style.display !== "none");
        if (!visibleItem) {
          this._showPlaceholder();
        }
      });
      }
        // Listen for mobile close button
    const closeBtn = document.querySelector(".mobile_close_fabric");
    if (closeBtn) {
      closeBtn.addEventListener("click", () => this._closeDropdown());
    }

    // Listen for clicks on the overlay container
    if (this.overlay) {
      this.overlay.addEventListener("click", () => this._closeDropdown());
    }
  }

  
  attributeChangedCallback(name, oldVal, newVal) {;
    
  if (name === "value") {
    if (newVal) {
      requestAnimationFrame(() => {
        this.selectedValue = newVal;
      });
    } else {
      this.value = null;
      this._clearSelectionStyles();
      this._showPlaceholder();
    }
  }
}

  get selectedValue() { return this.value; }
  set selectedValue(val) {
    const match = Array.from(this.items)
      .find(i => i.dataset.fabricProduct === val);
    if (match) this._selectItem({ currentTarget: match, silent: true });
  }

  
  init() {    
    this.header.addEventListener("click",  this._toggleDropdown.bind(this));

    this.items.forEach(item =>
      item.addEventListener("click", this._selectItem.bind(this))
    );

    document.addEventListener("click", this._handleOutside.bind(this));
  }

  disconnectedCallback() {
    document.removeEventListener("click", this._handleOutside.bind(this));
  }

  _toggleDropdown() {
    this.isOpen = !this.isOpen;
    this.list.classList.toggle("open",   this.isOpen);
    this.list.classList.toggle("closed", !this.isOpen);
    this.setAttribute("aria-expanded", this.isOpen);
    if (this.overlay) {
      this.overlay.style.display = this.isOpen ? "block" : "none";
    }
  }


_selectItem(evt) {
  const el = evt.currentTarget || evt.target;
  const label = el.textContent.trim();
  // 1️⃣ Find active category (trunks, briefs, vest)
  const wrapper = this.closest(".prodocut-tab-wrapper-inner.product-tab.medium-up--hide");
  let activeCategory = wrapper
      ?.querySelector("[js-sub-category] .tab-item.active .tab-item-text")
      ?.textContent.trim().toLowerCase();

  if (activeCategory) {
      activeCategory = activeCategory.replace(/\s+/g, "-"); // spaces → hyphens
    }
    const showAll = this.hasAttribute('js-display-default-product');

  // 2️⃣ Get matching data-* attribute
  let code = null;
  if (activeCategory) {
    const matchAttr = Object.keys(el.dataset).find(key => {
        // convert camelCase → kebab-case
        const kebabKey = key
          .replace(/([a-z0-9])([A-Z])/g, "$1-$2")
          .toLowerCase();
        if (showAll) return el.dataset[key];
        return kebabKey.includes(activeCategory);
      });

      if (matchAttr) {
        code = el.dataset[matchAttr];
      }
  }

  // 3️⃣ Fallback if no match found
  if (!code) {
    console.warn("No product handle found for", activeCategory, el.dataset);
    return;
  }

  // 4️⃣ If same as current, just toggle
  if (code === this.value) {
    this._toggleDropdown();
    return;
  }

  // 5️⃣ Set selection
  this._clearSelectionStyles();
  el.classList.add("selected");
  this.selectedText.textContent = label;

  this.value = code;
  this.setAttribute("value", code);
  this.setAttribute("text", label);

  if (!evt.silent) {
    this.dispatchEvent(new CustomEvent("change", {
      bubbles: true,
      detail: { value: code }
    }));
  }

  this._toggleDropdown();
}


  _clearSelectionStyles() {
    this.items.forEach(i => i.classList.remove("selected"));
  }

  _showPlaceholder() {
    this.selectedText.textContent =
      this.getAttribute("placeholder") || "Select Items";
  }

  _handleOutside(evt) {
    if (!this.contains(evt.target) && this.isOpen) this._toggleDropdown();
  }

  _closeDropdown() {
    this.isOpen = false;
    this.list.classList.remove("open");
    this.list.classList.add("closed");
    this.setAttribute("aria-expanded", "false");
    if (this.overlay) {
      this.overlay.style.display = "none";
    }
  }
}

customElements.define("mobile-fabric-dropdown", mobileFabricDropdown);
// secondary PDP